(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-hero"] && !Shopify.designMode) return;
  try {
    
/* Toggle `body.is-hero-active` while the affiliate hero is in the viewport.
   Same threshold values as the homepage hero so the swap timing matches. */
(function () {
  var hero = document.querySelector('[data-aff-hero]');
  if (!hero) return;

  if (!('IntersectionObserver' in window)) {
    document.body.classList.add('is-hero-active');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && entry.intersectionRatio > 0.05) {
        document.body.classList.add('is-hero-active');
      } else {
        document.body.classList.remove('is-hero-active');
      }
    });
  }, { threshold: [0, 0.05, 0.1] });

  io.observe(hero);
  // Hero is at the top of the page on load — start in the over-hero state so
  // there's no flash of the dark-text header before the observer fires.
  document.body.classList.add('is-hero-active');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate-manifesto"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   Manifesto feed — auto-scrolling vertical marquee + user override.

   Layered behavior:
   - Continuous auto-scroll runs in a RAF loop (≈ 33 CSS px / s upward).
   - User can take over at any time via wheel-over-feed, click-and-drag, or
     finger drag. Any user input briefly pauses the auto-scroll so they can
     read a message, then it resumes after ~1.8 s of no further input.
   - 3-copy buffer + measured-pixel wrap keeps the loop point flicker-free.
     The earlier `translateY(-33.333%)` keyframe never landed on an integer
     pixel between sets; JS measures `track.scrollHeight / 3` directly and
     wraps on that, so copy 2 lands pixel-perfect where copy 1 was.
   ========================================================================= */
(function () {
  function init(section) {
    var feed  = section.querySelector('.aff-mani__feed');
    var track = section.querySelector('.aff-mani__feed-track');
    if (!feed || !track) return;

    var y         = 0;    // translateY in CSS pixels (negative = scrolled up)
    var setH      = 0;    // measured height of one of the 3 identical sets
    var pausedTo  = 0;    // performance.now() — auto resumes after this time
    var lastT     = 0;    // last RAF timestamp
    var AUTO_PXPF = 0.25; // auto-scroll speed at 60fps (≈ 15 px/s)
    var PAUSE_MS  = 1800; // how long to pause auto after each user input

    var reduced = false;
    try { reduced = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    function measure() {
      // Use offsetTop of set 2's first article instead of `scrollHeight / 3`.
      // scrollHeight is rounded to an integer px; dividing by 3 gives a fractional
      // setH whose rounding error accumulates each loop, so set 2 lands a fraction
      // of a pixel off where set 1 started → visible "jump" at the wrap point.
      // offsetTop of the first article of set 2 IS the exact translate distance
      // that re-aligns set 2 over set 1's starting position. Bit-perfect.
      var articles = track.children;
      if (articles.length >= 3 && articles.length % 3 === 0) {
        var perSet = articles.length / 3;
        setH = articles[perSet].offsetTop;
      } else {
        setH = (track.scrollHeight || track.getBoundingClientRect().height) / 3;
      }
    }

    function wrap() {
      if (setH <= 0) return;
      // Modulo into (-setH, 0]. While-loops survive multi-set jumps from a
      // fast drag or trackpad fling.
      while (y <= -setH) y += setH;
      while (y > 0)     y -= setH;
    }

    function frame(t) {
      if (!lastT) lastT = t;
      var dt = Math.min((t - lastT) / 16.6667, 3); // clamp dt to absorb tab-switch jumps
      lastT = t;

      var auto = (t > pausedTo && !reduced) ? AUTO_PXPF : 0;
      y -= auto * dt;
      wrap();
      track.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0)';

      requestAnimationFrame(frame);
    }

    function bumpPause() { pausedTo = performance.now() + PAUSE_MS; }

    // --- Wheel (desktop) — wheel-over-feed scrolls the feed, NOT the page ---
    feed.addEventListener('wheel', function (e) {
      // Only consume vertical-dominant wheel. Horizontal trackpad swipes pass
      // through so they don't get hijacked.
      if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
      e.preventDefault();
      y -= e.deltaY;
      wrap();
      bumpPause();
    }, { passive: false });

    // --- Mouse drag (desktop) ----------------------------------------------
    var mouseDown = false, lastMouseY = 0;
    feed.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      mouseDown = true;
      lastMouseY = e.clientY;
      feed.classList.add('is-grabbing');
      bumpPause();
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!mouseDown) return;
      var dy = e.clientY - lastMouseY;
      lastMouseY = e.clientY;
      y += dy;
      wrap();
      bumpPause();
    });
    window.addEventListener('mouseup', function () {
      if (!mouseDown) return;
      mouseDown = false;
      feed.classList.remove('is-grabbing');
    });

    // --- Touch (mobile) -----------------------------------------------------
    // We DON'T capture touch on small viewports. Reason: on phones the feed
    // takes most of the screen, so a `touchmove` handler that calls
    // preventDefault traps page-scroll inside it — users swiping up to scroll
    // past the manifesto end up scrolling comments instead of the page. The
    // auto-marquee still runs underneath; users who want to read a specific
    // message can scroll the whole page so the message comes to rest, and
    // pinch-to-pause via `touch-action: pan-x` (set on the feed in CSS)
    // already lets the browser handle vertical pan as a normal page scroll.
    var TOUCH_VIEWPORT_MIN = 900;
    if (window.matchMedia && window.matchMedia('(min-width: ' + TOUCH_VIEWPORT_MIN + 'px)').matches) {
      var lastTouchY = null;
      feed.addEventListener('touchstart', function (e) {
        lastTouchY = e.touches[0].clientY;
        bumpPause();
      }, { passive: true });

      feed.addEventListener('touchmove', function (e) {
        if (lastTouchY == null) return;
        var ty = e.touches[0].clientY;
        var dy = ty - lastTouchY;
        lastTouchY = ty;
        y += dy;
        wrap();
        bumpPause();
        if (e.cancelable) e.preventDefault();
      }, { passive: false });

      function endTouch() { lastTouchY = null; }
      feed.addEventListener('touchend', endTouch);
      feed.addEventListener('touchcancel', endTouch);
    }

    // --- Boot ---------------------------------------------------------------
    function start() {
      measure();
      requestAnimationFrame(frame);
    }
    if (document.fonts && document.fonts.ready) {
      // Wait for web fonts so measured setH matches painted layout — FOUT
      // swap would otherwise shift the wrap point a few px after init.
      document.fonts.ready.then(start);
    } else {
      start();
    }

    window.addEventListener('resize', measure);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target === section || section.contains(e.target)) measure();
    });
  }

  document.querySelectorAll('.aff-mani').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cart-root]');
  if (!root) return;
  var SECTION = 'cart-drawer';
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    /* popup.liquid hides the floating offer widget via `body.cart-open` so the
       two don't collide over the checkout button. That class was never being
       set, leaving the rule dead. */
    document.body.classList.add('cart-open');
    document.body.style.overflow = 'hidden';
    var c = root.querySelector('.cart-drawer__close');
    if (c) c.focus();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Pull fresh markup for the drawer via the Section Rendering API and swap the inner panel.
  function render(state) {
    fetch('/?sections=' + SECTION + '&_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-root]');
        if (fresh) {
          root.innerHTML = fresh.innerHTML;
          // Sync data attributes Liquid recomputes (only innerHTML is swapped, not
          // the root element itself, so otherwise these freeze at page-load values).
          if (fresh.dataset.subPlans !== undefined) {
            root.dataset.subPlans = fresh.dataset.subPlans;
          }
        }
        updateCount();
      })
      .finally(function () { root.classList.remove('is-loading'); });
  }

  function updateCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
    });
  }

  // Rebalance every subscription line to the plan that matches the current
  // subscription quantity in the cart (1 → monthly, 2 → 2-month, 3+ → 3-month).
  // Bounded loop using /cart/change.js's own response (no extra /cart.js round-trip,
  // no caching surface), sequential because parallel calls race for the cart lock.
  function adjustSubscriptionPlans() {
    var plansCsv = root.dataset.subPlans || '';
    var plans = plansCsv.split(',').filter(Boolean);
    if (!plans.length) return Promise.resolve();

    function computeWrong(cart) {
      var subItems = cart.items.filter(function (i) { return i.selling_plan_allocation; });
      if (!subItems.length) return null;
      var subQty = subItems.reduce(function (s, i) { return s + i.quantity; }, 0);
      var idx = Math.min(Math.max(subQty - 1, 0), plans.length - 1);
      var targetPlanId = plans[idx];
      var wrong = subItems.filter(function (i) {
        return String(i.selling_plan_allocation.selling_plan.id) !== String(targetPlanId);
      })[0];
      return wrong ? { item: wrong, plan: targetPlanId } : null;
    }

    function iter(cart, attempt) {
      if (attempt > 6) return Promise.resolve();
      var w = computeWrong(cart);
      if (!w) return Promise.resolve();
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        cache: 'no-store',
        body: JSON.stringify({
          id: w.item.key,
          quantity: w.item.quantity,
          selling_plan: parseInt(w.plan, 10)
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (updatedCart) { return iter(updatedCart, attempt + 1); });
    }

    return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return iter(cart, 0); });
  }

  function api(url, body) {
    root.classList.add('is-loading');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        // Klaviyo "Added to Cart" — fire only for /cart/add.js responses so
        // qty changes and removes don't pollute the event stream.
        if (url.indexOf('/cart/add') === 0) {
          var addedItems = res && res.items ? res.items : (res ? [res] : []);
          document.dispatchEvent(new CustomEvent('cart:added', { detail: { items: addedItems } }));
        }
        return adjustSubscriptionPlans();
      })
      .then(function () { render(); });
  }

  function changeQty(key, qty) { return api('/cart/change.js', { id: key, quantity: qty }); }

  /* ---- delegated events (survive innerHTML swaps) ---- */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { close(); return; }

    var item = e.target.closest('.cart-item');
    if (item) {
      var key = item.dataset.key;
      var qtyVal = parseInt(item.querySelector('[data-qty-val]').textContent, 10) || 1;
      if (e.target.closest('[data-qty-inc]')) return changeQty(key, qtyVal + 1);
      if (e.target.closest('[data-qty-dec]')) return changeQty(key, Math.max(0, qtyVal - 1));
      if (e.target.closest('[data-remove]')) return changeQty(key, 0);
    }

    var addBtn = e.target.closest('[data-up-add]');
    if (addBtn) {
      var addBody = { id: parseInt(addBtn.dataset.variant, 10), quantity: 1 };
      // If the cart is currently a subscription cart, attach the first plan; the
      // global adjustSubscriptionPlans will rebalance to the correct tier plan after.
      var upWidget = root.querySelector('[data-cart-upsell]');
      var isSubCart = upWidget && upWidget.dataset.subCart === '1';
      if (isSubCart) {
        var planIds = (root.dataset.subPlans || '').split(',').filter(Boolean);
        if (planIds.length) addBody.selling_plan = parseInt(planIds[0], 10);
      }
      return api('/cart/add.js', addBody);
    }

    if (e.target.closest('[data-convert-sub]')) {
      // Walk the cart sequentially, fetching fresh state each loop, converting the
      // next remaining one-time line to its product's first selling plan, until
      // none remain. Using fresh state avoids any DOM-snapshot staleness.
      var firstPlan = parseInt((root.dataset.subPlans || '').split(',')[0], 10);
      if (!firstPlan) return;
      root.classList.add('is-loading');
      var convertNext = function () {
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var next = cart.items.filter(function (i) { return !i.selling_plan_allocation; })[0];
            if (!next) return;
            return fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: next.key, quantity: next.quantity, selling_plan: firstPlan })
            }).then(function (r) { return r.json(); }).then(convertNext);
          });
      };
      convertNext()
        .then(function () { return adjustSubscriptionPlans(); })
        .then(function () { render(); });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // open from anywhere
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-trigger]')) { e.preventDefault(); open(); }
  });
  document.addEventListener('cart:added', function () {
    root.classList.add('is-loading');
    adjustSubscriptionPlans().then(function () { render(); open(); });
  });

  window.HydrawCart = { open: open, close: close, refresh: render };
  updateCount();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electrolyte-map"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.elmap').forEach(function (section) {
    var connect = section.querySelector('.elmap__connect');
    if (!connect) return;
    var labels = section.querySelectorAll('.elmap__label');
    var mediaMobile = window.matchMedia('(max-width: 1200px)');

    function alignDesktop() {
      var srect = section.getBoundingClientRect();
      if (!srect.width) return;
      var lefts = [];
      labels.forEach(function (label) {
        var m = label.className.match(/elmap__label--(\d)/);
        if (!m) return;
        var line = connect.querySelector('.elmap__line--v' + m[1]);
        if (!line) return;
        var lrect = label.getBoundingClientRect();
        var centerPct = ((lrect.left + lrect.width / 2) - srect.left) / srect.width * 100;
        line.style.left = centerPct + '%';
        lefts.push(centerPct);
      });
      if (lefts.length > 1) {
        var mid = connect.querySelector('.elmap__line--mid');
        if (mid) {
          var minL = Math.min.apply(null, lefts);
          var maxL = Math.max.apply(null, lefts);
          mid.style.left = minL + '%';
          mid.style.right = (100 - maxL) + '%';
        }
      }
    }

    function alignMobile() {
      var SW = section.offsetWidth;
      if (!SW) return;
      var H_PAD = 14;
      var V_INSET = 11; // stop the vertical short of lower.midY so the dot sits
                        // above the label text instead of on top of it
      var labelArr = Array.prototype.slice.call(labels);
      for (var i = 0; i < labelArr.length - 1; i++) {
        var u = labelArr[i], l = labelArr[i + 1];
        var uMidY = u.offsetTop + u.offsetHeight / 2;
        var lMidY = l.offsetTop + l.offsetHeight / 2 - V_INSET;
        var lMidX = l.offsetLeft + l.offsetWidth / 2;  // dead-center of lower
        var upperOnLeft = (u.offsetLeft + u.offsetWidth / 2) < SW / 2;
        var zig = connect.querySelector('.elmap__zig--' + (i + 1) + (i + 2));
        if (!zig) continue;

        // Vertical sits at lower's horizontal center. Top horizontal connects
        // back to the upper label's text-end, with a 4px breathing gap.
        var topEnd, topW, dirClass, otherClass;
        if (upperOnLeft) {
          topEnd = u.offsetLeft + u.offsetWidth + H_PAD;  // upper's right edge + 4px
          topW   = lMidX - topEnd;                        // horizontal width going right
          dirClass = 'elmap__zig--lr';
          otherClass = 'elmap__zig--rl';
        } else {
          topEnd = u.offsetLeft - H_PAD;                  // upper's left edge - 4px
          topW   = topEnd - lMidX;                        // horizontal width going left
          dirClass = 'elmap__zig--rl';
          otherClass = 'elmap__zig--lr';
        }

        zig.classList.add(dirClass);
        zig.classList.remove(otherClass);
        zig.style.left   = lMidX + 'px';
        zig.style.top    = uMidY + 'px';
        zig.style.height = Math.max(0, lMidY - uMidY) + 'px';
        zig.style.setProperty('--zw-top', Math.max(0, topW) + 'px');
        zig.style.right  = '';
      }
    }

    function align() {
      if (mediaMobile.matches) alignMobile();
      else alignDesktop();
    }

    align();
    if (document.readyState !== 'complete') window.addEventListener('load', align);
    if ('ResizeObserver' in window) new ResizeObserver(align).observe(section);
    else window.addEventListener('resize', align);

    // Sequential reveal on mobile — when the section enters the viewport, fade
    // in label 1, then for each rung draw its horizontal, draw its vertical
    // (which fades the end-dot in), and finally fade in the next label.
    function runSequence() {
      if (!mediaMobile.matches) {
        // Desktop: just show all labels at once (no sequential reveal).
        labels.forEach(function (l) { l.classList.add('is-shown'); });
        return;
      }
      align();
      var labelArr = Array.prototype.slice.call(labels);
      labelArr[0].classList.add('is-shown');
      var STEP = 520; // ms per rung cycle (h-draw + v-draw + next label fade)
      var H_DUR = 260, V_DUR = 260;
      var base = 280; // delay before the first rung starts drawing
      for (var i = 0; i < labelArr.length - 1; i++) {
        (function (idx) {
          var t = base + idx * STEP;
          var zig = connect.querySelector('.elmap__zig--' + (idx + 1) + (idx + 2));
          var next = labelArr[idx + 1];
          setTimeout(function () { if (zig) zig.classList.add('is-h-drawn'); }, t);
          setTimeout(function () { if (zig) zig.classList.add('is-v-drawn'); }, t + H_DUR);
          setTimeout(function () { if (next) next.classList.add('is-shown'); }, t + H_DUR + V_DUR - 80);
        })(i);
      }
    }

    var played = false;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !played) {
            played = true;
            runSequence();
            io.disconnect();
          }
        });
      }, { threshold: 0.25 });
      io.observe(section);
    } else {
      // Older browsers — just show everything immediately.
      played = true;
      labels.forEach(function (l) { l.classList.add('is-shown'); });
      section.querySelectorAll('.elmap__zig').forEach(function (z) {
        z.classList.add('is-h-drawn', 'is-v-drawn');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-questions"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mqDesktop = window.matchMedia('(min-width: 900px)');

  document.querySelectorAll('[data-faqq]').forEach(function (section) {
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-faqq-item]'));
    if (!items.length) return;

    function panelOf(item) { return item.querySelector('[data-faqq-panel]'); }
    function btnOf(item)   { return item.querySelector('[data-faqq-toggle]'); }

    function expand(item) {
      var p = panelOf(item), b = btnOf(item);
      item.classList.add('is-open');
      if (b) b.setAttribute('aria-expanded', 'true');
      if (p) p.style.maxHeight = p.scrollHeight + 'px';
    }
    function collapse(item) {
      var p = panelOf(item), b = btnOf(item);
      if (p) {
        p.style.maxHeight = p.scrollHeight + 'px';
        void p.offsetHeight;
        p.style.maxHeight = '0px';
      }
      item.classList.remove('is-open');
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    items.forEach(function (item, i) {
      var btn = btnOf(item);
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (item.classList.contains('is-open')) { collapse(item); return; }
        if (mqDesktop.matches) {
          // Single-open on desktop — collapse others first.
          items.forEach(function (other, j) {
            if (j === i) expand(other);
            else if (other.classList.contains('is-open')) collapse(other);
          });
        } else {
          // Additive on mobile so layout doesn't jump as the user explores.
          expand(item);
        }
      });
    });

    // All questions ship closed by default. Only set inline max-height for an
    // item that explicitly has `.is-open` in markup — no fall-back to the
    // first item, so the section loads with every panel collapsed.
    var initialIdx = items.findIndex(function (it) { return it.classList.contains('is-open'); });
    if (initialIdx >= 0) {
      var initialPanel = panelOf(items[initialIdx]);
      if (initialPanel) initialPanel.style.maxHeight = initialPanel.scrollHeight + 'px';
    }

    // Reflow open panels on content/layout change (font swap, resize).
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        items.forEach(function (it) {
          if (!it.classList.contains('is-open')) return;
          var p = panelOf(it);
          if (p) p.style.maxHeight = p.scrollHeight + 'px';
        });
      });
      items.forEach(function (it) {
        var p = panelOf(it);
        if (p && p.firstElementChild) ro.observe(p.firstElementChild);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  const burger = document.querySelector('[data-burger]');
  const close = document.querySelector('[data-burger-close]');
  const menu = document.querySelector('[data-mobile-menu]');
  const headerEl = document.querySelector('[data-site-header]');
  const headerWrap = headerEl ? headerEl.closest('.shopify-section-group-header-group') : null;

  // Mirror the .is-scrolled class onto the wrapper too, so the
  // sticky parent gets the blur/shadow even though :has() may be unsupported.
  if (headerEl && headerWrap) {
    const sync = () => {
      if (headerEl.classList.contains('is-scrolled')) headerWrap.classList.add('is-scrolled');
      else headerWrap.classList.remove('is-scrolled');
    };
    new MutationObserver(sync).observe(headerEl, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  if (!burger || !menu) return;

  function open() {
    menu.hidden = false;
    requestAnimationFrame(() => menu.classList.add('is-open'));
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function shut() {
    menu.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(() => { menu.hidden = true; }, 320);
  }
  burger.addEventListener('click', open);
  close && close.addEventListener('click', shut);
  menu.addEventListener('click', (e) => {
    if (e.target.closest('a')) shut();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !menu.hidden) shut();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var hero = document.querySelector('.hero--video[data-hero-fullscreen]');
  if (!hero) return;

  /* ---- Lazy-load the matching video so we don't block initial paint ---- */
  function loadActiveVideo() {
    var w = window.innerWidth;
    var video = hero.querySelector(w < 768 ? '.hero__video--mobile' : '.hero__video--desktop');
    if (!video) return;
    var src = video.querySelector('source');
    if (src && !video.src) {
      // Trigger load by setting load() — source already in DOM.
      video.load();
    }
    video.addEventListener('canplay', function () { video.classList.add('is-loaded'); }, { once: true });
    // Fallback in case canplay never fires.
    setTimeout(function () { video.classList.add('is-loaded'); }, 1500);
  }
  // Defer until idle / first interaction.
  if ('requestIdleCallback' in window) requestIdleCallback(loadActiveVideo, { timeout: 1200 });
  else setTimeout(loadActiveVideo, 600);

  /* ---- Header transparency toggle ---- */
  // While ANY part of the hero is in the viewport the body gets `.is-hero-active`.
  // The IntersectionObserver fires at thresholds 0 and 0.1 so the swap happens
  // smoothly as the hero scrolls in / out.
  if (!('IntersectionObserver' in window)) {
    document.body.classList.add('is-hero-active');
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && entry.intersectionRatio > 0.05) {
        document.body.classList.add('is-hero-active');
      } else {
        document.body.classList.remove('is-hero-active');
      }
    });
  }, { threshold: [0, 0.05, 0.1] });
  io.observe(hero);
  // Initial state — if hero is at top on load, mark active immediately.
  document.body.classList.add('is-hero-active');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use"] && !Shopify.designMode) return;
  try {
    
(function () {
  const videos = document.querySelectorAll('[data-autoplay-in-view]');
  if (!('IntersectionObserver' in window) || !videos.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const v = entry.target;
      if (entry.isIntersecting) {
        v.play().catch(() => { /* autoplay blocked, leave silent */ });
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.4 });
  videos.forEach((v) => io.observe(v));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-body"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mqDesktop = window.matchMedia('(min-width: 900px)');

  document.querySelectorAll('[data-hydbody]').forEach(function (section) {
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-hydbody-item]'));
    if (!items.length) return;

    function panelOf(item) { return item.querySelector('[data-hydbody-panel]'); }
    function btnOf(item)   { return item.querySelector('[data-hydbody-toggle]'); }

    function expand(item) {
      var p = panelOf(item), b = btnOf(item);
      item.classList.add('is-open');
      if (b) b.setAttribute('aria-expanded', 'true');
      if (p) p.style.maxHeight = p.scrollHeight + 'px';
    }
    function collapse(item) {
      var p = panelOf(item), b = btnOf(item);
      if (p) {
        p.style.maxHeight = p.scrollHeight + 'px';
        void p.offsetHeight;
        p.style.maxHeight = '0px';
      }
      item.classList.remove('is-open');
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    function open(i) {
      if (mqDesktop.matches) {
        items.forEach(function (other, j) {
          if (j === i) expand(other);
          else if (other.classList.contains('is-open')) collapse(other);
        });
      } else {
        if (!items[i].classList.contains('is-open')) expand(items[i]);
      }
      requestAnimationFrame(function () {
        var openP = panelOf(items[i]);
        if (openP) openP.style.maxHeight = openP.scrollHeight + 'px';
      });
    }

    items.forEach(function (item, i) {
      var btn = btnOf(item);
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (item.classList.contains('is-open')) collapse(item);
        else open(i);
      });
    });

    // Initial state — all accordions start CLOSED. Only set inline max-height
    // for an item that's already `.is-open` in markup (none in the current
    // template, but the check leaves the door open for future overrides).
    var initialIdx = items.findIndex(function (it) { return it.classList.contains('is-open'); });
    if (initialIdx >= 0) {
      var initialPanel = panelOf(items[initialIdx]);
      if (initialPanel) initialPanel.style.maxHeight = initialPanel.scrollHeight + 'px';
    }

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        items.forEach(function (it) {
          if (!it.classList.contains('is-open')) return;
          var p = panelOf(it);
          if (p) p.style.maxHeight = p.scrollHeight + 'px';
        });
      });
      items.forEach(function (it) {
        var p = panelOf(it);
        if (p && p.firstElementChild) ro.observe(p.firstElementChild);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Click-to-expand stat accordions — animate max-height between 0 and content height.
  document.querySelectorAll('[data-acc-toggle]').forEach((btn) => {
    const wrap = btn.closest('.stat-acc');
    const panel = wrap && wrap.querySelector('.stat-acc__panel');
    if (!wrap || !panel) return;

    btn.addEventListener('click', () => {
      const willOpen = !wrap.classList.contains('is-open');
      if (willOpen) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        // Lock the current rendered height before transitioning back to 0.
        panel.style.maxHeight = panel.scrollHeight + 'px';
        void panel.offsetHeight;
        panel.style.maxHeight = '0px';
      }
      wrap.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', String(willOpen));
    });

    // Keep panel sized to content when its size changes (responsive resize).
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => {
        if (wrap.classList.contains('is-open')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
      const inner = panel.querySelector('.stat-acc__inner');
      if (inner) ro.observe(inner);
    }
  });

  // Animate numeric values up to their target when the stat enters the viewport.
  const counters = document.querySelectorAll('[data-counter]');
  if (!('IntersectionObserver' in window) || !counters.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      io.unobserve(el);
      const raw = el.dataset.target || el.textContent;
      const num = parseFloat(raw);
      if (Number.isNaN(num)) return;
      if (reduce) { el.textContent = raw; return; }
      const suffix = raw.replace(/^[\d.]+/, '');
      const start = performance.now();
      const dur = 1100;
      function step(t) {
        const p = Math.min(1, (t - start) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(num * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = raw;
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  counters.forEach((c) => io.observe(c));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-strip]').forEach(function (section) {
    var items = section.querySelectorAll('[data-strip-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-strip-toggle]');
      var panel = item.querySelector('[data-strip-panel]');
      if (!btn || !panel) return;

      function open() {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
      function close() {
        // Pin current rendered height so the transition can interpolate to 0.
        panel.style.maxHeight = panel.scrollHeight + 'px';
        void panel.offsetHeight;
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        panel.style.maxHeight = '0px';
      }

      // Hover opens (no auto-close on leave — staying open until the user
      // clicks the button is intentional, mirrors the spec).
      item.addEventListener('mouseenter', function () {
        if (!item.classList.contains('is-open')) open();
      });

      // Click toggles. If currently open (the common case after a hover-open)
      // it closes; if closed (touch / keyboard with no hover) it opens.
      btn.addEventListener('click', function () {
        if (item.classList.contains('is-open')) close();
        else open();
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          if (item.classList.contains('is-open')) panel.style.maxHeight = panel.scrollHeight + 'px';
        }).observe(panel.firstElementChild || panel);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  var section = document.querySelector('[data-main-cart]');
  if (!section) return;

  // Rebalance every subscription line to the plan that matches the current
  // subscription quantity (1 → monthly, 2 → 2-month, 3+ → 3-month). Same
  // logic as the cart drawer: sequential /cart/change.js iterations using the
  // response cart, so we never race the cart lock. Resolves to true if any
  // change was actually made.
  function adjustSubscriptionPlans() {
    var plansCsv = section.dataset.subPlans || '';
    var plans = plansCsv.split(',').filter(Boolean);
    if (!plans.length) return Promise.resolve(false);

    function computeWrong(cart) {
      var subItems = cart.items.filter(function (i) { return i.selling_plan_allocation; });
      if (!subItems.length) return null;
      var subQty = subItems.reduce(function (s, i) { return s + i.quantity; }, 0);
      var idx = Math.min(Math.max(subQty - 1, 0), plans.length - 1);
      var targetPlanId = plans[idx];
      var wrong = subItems.filter(function (i) {
        return String(i.selling_plan_allocation.selling_plan.id) !== String(targetPlanId);
      })[0];
      return wrong ? { item: wrong, plan: targetPlanId } : null;
    }

    function iter(cart, attempt, changed) {
      if (attempt > 6) return Promise.resolve(changed);
      var w = computeWrong(cart);
      if (!w) return Promise.resolve(changed);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        cache: 'no-store',
        body: JSON.stringify({
          id: w.item.key,
          quantity: w.item.quantity,
          selling_plan: parseInt(w.plan, 10)
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (updatedCart) { return iter(updatedCart, attempt + 1, true); });
    }

    return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return iter(cart, 0, false); });
  }

  function changeQty(key, qty) {
    section.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
      cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function () { return adjustSubscriptionPlans(); })
      .then(function () {
        // Full reload re-renders line items + total with the corrected plans.
        window.location.reload();
      })
      .catch(function () {
        section.classList.remove('is-loading');
      });
  }

  section.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.dataset.key;
    var valEl = line.querySelector('[data-qty-val]');
    var val = valEl ? parseInt(valEl.textContent, 10) || 1 : 1;
    if (e.target.closest('[data-qty-inc]')) { e.preventDefault(); return changeQty(key, val + 1); }
    if (e.target.closest('[data-qty-dec]')) { e.preventDefault(); return changeQty(key, Math.max(0, val - 1)); }
    if (e.target.closest('[data-remove]'))  { e.preventDefault(); return changeQty(key, 0); }
  });

  // On initial page load, rebalance plans in case the user landed on /cart
  // with an out-of-sync cart (e.g., direct link or browser back from checkout).
  // Only reload if rebalance actually changed something — otherwise no flash.
  adjustSubscriptionPlans().then(function (changed) {
    if (changed) window.location.reload();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    /* i18n: {% javascript %} is not Liquid-rendered, so translated strings
       arrive via data-* attributes on the section root. */
    function T(key, fallback) { return (root.dataset && root.dataset[key]) || fallback; }
    var form = root.querySelector('[data-pdp-form]');
    if (!form) return;

    var data = {};
    try { data = JSON.parse(root.querySelector('[data-pdp-data]').textContent); } catch (e) { data = { variants: [] }; }

    var packs = Array.prototype.slice.call(form.querySelectorAll('[data-pack]'));
    var ptypeBtns = Array.prototype.slice.call(form.querySelectorAll('[data-ptype]'));
    var freqWrap = form.querySelector('[data-frequency]');
    var freqSelect = form.querySelector('[data-frequency-select]');
    var atc = form.querySelector('[data-atc]');
    var feedback = form.querySelector('[data-feedback]');
    var PER_SUFFIX = root.dataset.perSuffix || '/ vnt.';

    var state = {
      pack: null,
      purchase: root.dataset.subDefault === '1' ? 'subscription' : 'onetime',
      planId: null
    };

    function variantData(id) {
      for (var i = 0; i < data.variants.length; i++) { if (String(data.variants[i].id) === String(id)) return data.variants[i]; }
      return null;
    }
    function money(cents) {
      return (cents / 100).toLocaleString('lt-LT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    // Discount in cents — a € amount wins over a % if both are set.
    function discCents(base, pct, eur) {
      if (eur && eur > 0) return Math.min(base, Math.round(eur * 100));
      if (pct && pct > 0) return Math.round(base * pct / 100);
      return 0;
    }

    // Base = sum of the chosen flavor prices across the pack's rows.
    // Subscription total prefers the actual selling-plan allocation price per
    // variant (matches what Shopify will charge), falling back to the pack's
    // section-defined sub_pct/sub_eur if allocations aren't available.
    function packTotals(pack) {
      var otPct = parseFloat(pack.dataset.otPct) || 0, otEur = parseFloat(pack.dataset.otEur) || 0;
      var subPct = parseFloat(pack.dataset.subPct) || 0, subEur = parseFloat(pack.dataset.subEur) || 0;
      var units = parseInt(pack.dataset.units, 10) || 1;
      var planIdx = Math.min(Math.max(units - 1, 0), 2);
      var rows = pack.querySelectorAll('[data-flavor-row]');
      var base = 0;
      var subFromPlans = 0;
      var subPlansResolved = true;
      rows.forEach(function (row) {
        var active = row.querySelector('.pdp-flavor.is-active') || row.querySelector('.pdp-flavor:not([disabled])');
        var vd = active ? variantData(active.dataset.variant) : null;
        if (vd) {
          base += vd.price;
          if (vd.plans && vd.plans[planIdx] && typeof vd.plans[planIdx].price === 'number') {
            subFromPlans += vd.plans[planIdx].price;
          } else {
            subPlansResolved = false;
          }
        }
      });
      return {
        base: base,
        oneNow: base - discCents(base, otPct, otEur),
        subNow: subPlansResolved && subFromPlans > 0 ? subFromPlans : (base - discCents(base, subPct, subEur)),
        units: units
      };
    }

    function updatePrices() {
      packs.forEach(function (pack) {
        var t = packTotals(pack);
        var nowEl = pack.querySelector('[data-price-now]');
        var wasEl = pack.querySelector('[data-price-was]');
        var perEl = pack.querySelector('[data-price-per]');
        if (!nowEl) return;
        var now = state.purchase === 'subscription' ? t.subNow : t.oneNow;
        nowEl.textContent = money(now);
        if (wasEl) {
          if (now < t.base) { wasEl.textContent = money(t.base); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
        if (perEl && t.units > 1) { perEl.textContent = money(Math.round(now / t.units)) + ' ' + PER_SUFFIX; }
      });
    }

    // Pack tier determines the subscription plan: units 1 → monthly,
    // 2 → every 2 months, 3 → every 3 months (positional mapping into
    // product.selling_plan_groups[0].selling_plans).
    function planIdForPack(pack) {
      if (!pack || !data.plans || !data.plans.length) return null;
      var units = parseInt(pack.dataset.units, 10) || 1;
      var idx = Math.min(Math.max(units - 1, 0), data.plans.length - 1);
      return data.plans[idx].id;
    }

    function syncSubscriptionPlan() {
      if (state.purchase === 'subscription') state.planId = planIdForPack(state.pack);
      else state.planId = null;
    }

    function selectPack(pack) {
      packs.forEach(function (p) {
        var on = p === pack;
        p.classList.toggle('is-selected', on);
        p.querySelector('[data-pack-head]').setAttribute('aria-checked', on ? 'true' : 'false');
      });
      state.pack = pack;
      syncSubscriptionPlan();
    }

    function setPurchase(type) {
      state.purchase = type;
      ptypeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.ptype === type ? 'true' : 'false'); });
      syncSubscriptionPlan();
      // Frequency is now pack-determined; the dropdown stays hidden.
      if (freqWrap) freqWrap.hidden = true;
      updatePrices();
    }

    /* ---- events ---- */
    packs.forEach(function (pack) {
      pack.querySelector('[data-pack-head]').addEventListener('click', function () { selectPack(pack); updatePrices(); updateMainImage(); });
      pack.querySelectorAll('[data-flavor-row]').forEach(function (row) {
        row.querySelectorAll('.pdp-flavor').forEach(function (sw) {
          if (sw.disabled) return;
          sw.addEventListener('click', function () {
            row.querySelectorAll('.pdp-flavor').forEach(function (s) { s.classList.remove('is-active'); });
            sw.classList.add('is-active');
            updatePrices();
            updateMainImage();
          });
        });
        // Expand the hit area: a click anywhere in the cell/opt (label included)
        // routes to the inner swatch button. The swatch's own click handler stops
        // re-entry by itself (event default propagation chain).
        row.querySelectorAll('.pdp-flavor-opt, .pdp-flavor-cell').forEach(function (container) {
          container.style.cursor = 'pointer';
          container.addEventListener('click', function (e) {
            if (e.target.closest('.pdp-flavor')) return;
            var sw = container.querySelector('.pdp-flavor');
            if (sw && !sw.disabled) sw.click();
          });
        });
      });
    });
    ptypeBtns.forEach(function (b) { b.addEventListener('click', function () { setPurchase(b.dataset.ptype); }); });
    if (freqSelect) freqSelect.addEventListener('change', function () { state.planId = freqSelect.value; updatePrices(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (feedback) feedback.hidden = true;
      if (!state.pack || !data.variants.length) { showFeedback(T('tUnavailable','This product is currently unavailable.'), true); return; }

      var counts = {};
      state.pack.querySelectorAll('[data-flavor-row]').forEach(function (row) {
        var active = row.querySelector('.pdp-flavor.is-active') || row.querySelector('.pdp-flavor:not([disabled])');
        if (active && active.dataset.variant) { var id = active.dataset.variant; counts[id] = (counts[id] || 0) + 1; }
      });
      var items = Object.keys(counts).map(function (id) {
        var vid = parseInt(id, 10);
        if (!vid || isNaN(vid)) return null;
        var it = { id: vid, quantity: counts[id] };
        if (state.purchase === 'subscription') {
          var vd = variantData(id);
          var match = null;
          if (vd && vd.plans && state.planId) {
            for (var pi = 0; pi < vd.plans.length; pi++) {
              if (String(vd.plans[pi].id) === String(state.planId)) { match = vd.plans[pi].id; break; }
            }
          }
          // Prefer the variant's allocation for this plan id; otherwise fall back
          // to the variant's first plan, then to the product-level planId.
          var planToUse = match
            || (vd && vd.plans && vd.plans.length ? vd.plans[0].id : null)
            || state.planId;
          if (planToUse) it.selling_plan = parseInt(planToUse, 10);
        }
        return it;
      }).filter(Boolean);
      if (!items.length) { showFeedback(T('tSelectFlavor','Please choose a flavor.'), true); return; }

      atc.disabled = true;

      // Pre-flight: hit /products/{handle}.js for fresh variant data so we can
      // tell the user *why* an add will fail (sold out vs requires subscription)
      // before Shopify rejects with a generic message.
      var handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
      var preflight = handle
        ? fetch('/products/' + handle + '.js?_=' + Date.now(), { cache: 'no-store' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; })
        : Promise.resolve(null);

      preflight
        .then(function (product) {
          if (product && product.variants) {
            for (var i = 0; i < items.length; i++) {
              var v = product.variants.find(function (vv) { return vv.id === items[i].id; });
              if (!v) continue;
              if (!v.available) {
                throw new Error(T('tSoldOut','“{{ name }}” is sold out.').replace('{{ name }}', v.name));
              }
              if (v.requires_selling_plan && !items[i].selling_plan) {
                throw new Error(T('tSubscriptionOnly','“{{ name }}” requires a subscription.').replace('{{ name }}', v.name));
              }
            }
          }
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || T('tAddFailed',"We couldn't add this to your cart.")); });
            return r.json();
          });
        })
        .then(function (addRes) {
          var addedItems = addRes && addRes.items ? addRes.items : (addRes ? [addRes] : []);
          document.dispatchEvent(new CustomEvent('cart:added', { detail: { items: addedItems } }));
          if (window.HydrawCart && window.HydrawCart.open) window.HydrawCart.open();
          else window.location.href = '/cart';
        })
        .catch(function (err) { showFeedback(err.message || T('tAddFailed',"We couldn't add this to your cart."), true); })
        .finally(function () { atc.disabled = false; });
    });

    function showFeedback(msg, isError) {
      if (!feedback) return;
      feedback.textContent = msg; feedback.hidden = false;
      feedback.classList.toggle('pdp__feedback--error', !!isError);
    }

    /* ---- accordions (animated, native <details> kept for semantics) ---- */
    root.querySelectorAll('.pdp-acc').forEach(function (acc) {
      var sum = acc.querySelector('.pdp-acc__summary');
      if (!sum) return;
      if (acc.open) acc.classList.add('is-open');
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (acc.classList.contains('is-open')) {
          acc.classList.remove('is-open');
          window.setTimeout(function () { if (!acc.classList.contains('is-open')) acc.open = false; }, 380);
        } else {
          acc.open = true;
          requestAnimationFrame(function () { acc.classList.add('is-open'); });
        }
      });
    });

    /* ---- main image + gallery slider ---- */
    var mainImg = root.querySelector('.pdp__stage img');
    var stage = root.querySelector('[data-stage]');
    var thumbsContainer = root.querySelector('[data-thumbs]');
    var allThumbs = thumbsContainer ? thumbsContainer.querySelectorAll('[data-thumb]') : [];
    var galleryPrev = root.querySelector('[data-gallery-prev]');
    var galleryNext = root.querySelector('[data-gallery-next]');
    var progressFill = root.querySelector('[data-pdp-progress-fill]');
    var progressEl = root.querySelector('[data-pdp-progress]');
    var slideIndex = 0;

    // Progress pill (mobile) — fill width grows from a minimum nub at slide 0
    // to 100% at the last slide. Identical curve to the scenarios slider so
    // the indicator language is consistent across the site.
    var PROGRESS_MIN_PCT = 18;
    function updateProgress() {
      if (!progressFill) return;
      var n = allThumbs.length;
      if (n <= 1) { progressFill.style.width = '100%'; return; }
      var pct = (slideIndex / (n - 1)) * 100;
      progressFill.style.width = (PROGRESS_MIN_PCT + (100 - PROGRESS_MIN_PCT) * (pct / 100)) + '%';
    }

    // <picture> element + its mobile <source>. JS swaps source.srcset for the
    // mobile-only image on slide change, and the browser re-evaluates which
    // image to show based on the source's media query.
    var stagePic = root.querySelector('[data-pic]');
    var stageSource = stagePic ? stagePic.querySelector('[data-pic-mobile]') : null;

    // Seed currentImg with whichever URL the server rendered into the stage
    // <img> so the first goTo(0) → setMainImage call no-ops (preserving the
    // responsive srcset from image_tag) when slide 0 happens to match.
    var currentImg = mainImg ? (mainImg.getAttribute('src') || '') : '';

    // Preload the next image, fade the current one out, swap, fade back in.
    // `mobileUrl` updates the <picture>'s mobile <source>; desktop viewports
    // ignore the source (its media query doesn't match) and use the <img> src.
    //
    // Critical: we preload the URL the BROWSER WILL ACTUALLY DISPLAY at the
    // current viewport — mobile sees the <source>'s mobile URL, desktop sees
    // the <img>'s desktop URL. Preloading the wrong one let the fade-in run
    // before the displayed image had loaded, so the previous slide stayed
    // visible during the fade and then snapped to the new image once it
    // arrived (the "double blink" the user noticed on first pass; second
    // pass worked because the asset was in the browser cache by then).
    function setMainImage(url, mobileUrl) {
      if (!mainImg || !url || url === currentImg) return;
      currentImg = url;
      var isMobile = window.matchMedia('(max-width: 899px)').matches;
      var preloadUrl = isMobile ? (mobileUrl || url) : url;
      var pre = new Image();
      pre.onload = function () {
        mainImg.style.opacity = '0';
        window.setTimeout(function () {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          if (stageSource) stageSource.srcset = mobileUrl || url;
          mainImg.src = url;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { mainImg.style.opacity = '1'; });
          });
        }, 220);
      };
      pre.onerror = function () {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        if (stageSource) stageSource.srcset = mobileUrl || url;
        mainImg.src = url;
      };
      pre.src = preloadUrl;
    }

    function slideUrlsAt(idx) {
      var t = allThumbs[idx];
      if (!t) return { desktop: '', mobile: '' };
      var d = t.dataset.full || '';
      var m = t.dataset.fullMobile || d;
      return { desktop: d, mobile: m };
    }

    function goTo(idx) {
      var n = allThumbs.length;
      if (!n) return;
      idx = ((idx % n) + n) % n; // loop
      slideIndex = idx;
      for (var i = 0; i < n; i++) {
        allThumbs[i].classList.toggle('is-active', i === idx);
      }
      // Keep the active thumb visible in the 3-up window
      var thumb = allThumbs[idx];
      if (thumb && thumbsContainer) {
        var left = thumb.offsetLeft;
        var visStart = thumbsContainer.scrollLeft;
        var visEnd = visStart + thumbsContainer.clientWidth;
        if (left < visStart || left + thumb.offsetWidth > visEnd) {
          thumbsContainer.scrollTo({ left: left, behavior: 'smooth' });
        }
      }
      var urls = slideUrlsAt(idx);
      setMainImage(urls.desktop, urls.mobile);
      updateProgress();
      // Keep the magnifier in sync with the new slide's image while it stays
      // open (e.g. user clicks the arrow with the lens active on desktop).
      if (lensActive) showLens();
    }

    // Pack/flavor change: jump back to slide 0 of the current gallery. With
    // the pack thumb gone, slide 0 is just allThumbs[0] of whatever flavor
    // template (or universal set) is currently mounted — no dynamic image
    // mutation needed here.
    function updateMainImage() { goTo(0); }

    if (galleryPrev) galleryPrev.addEventListener('click', function () { goTo(slideIndex - 1); });
    if (galleryNext) galleryNext.addEventListener('click', function () { goTo(slideIndex + 1); });
    // Wire click for every thumb; hide arrows / progress when there's only one.
    for (var ti = 0; ti < allThumbs.length; ti++) {
      (function (i, t) { t.addEventListener('click', function () { goTo(i); }); })(ti, allThumbs[ti]);
    }
    if (allThumbs.length <= 1) {
      if (galleryPrev) galleryPrev.hidden = true;
      if (galleryNext) galleryNext.hidden = true;
      if (progressEl) progressEl.hidden = true;
    }

    // Initial fill so the pill renders the minimum nub on first paint.
    updateProgress();

    /* ---- magnifier lens ---- */
    var lens = null;
    var lensActive = false;
    // Last known cursor/touch position — used to re-run the safe-zone check
    // after a slide change (arrow click) so the lens stays hidden if the
    // pointer is still parked over the arrow it just clicked.
    var lastLensClientX = 0, lastLensClientY = 0;
    if (stage) {
      lens = document.createElement('div');
      lens.className = 'pdp__lens';
      stage.appendChild(lens);
    }

    // The lens shows the current slide's full-resolution image — desktop URL
    // by default, mobile URL when the viewport matches (since the mobile crop
    // may be a different aspect/composition). Falls back to the stage <img>
    // src if no thumb data is available.
    function currentSlideFullUrl() {
      var isMobile = window.matchMedia('(max-width: 899px)').matches;
      var t = allThumbs[slideIndex];
      if (t) {
        return isMobile ? (t.dataset.fullMobile || t.dataset.full || '') : (t.dataset.full || '');
      }
      return mainImg ? (mainImg.getAttribute('src') || '') : '';
    }

    function showLens() {
      if (!lens) return;
      var url = currentSlideFullUrl();
      if (!url) return;
      lens.style.backgroundImage = 'url("' + url.replace(/"/g, '\\"') + '")';
      // Defer to updateLensPosition for visibility — it runs the safe-zone
      // check against the last known cursor coords, so the lens stays hidden
      // when "show" is triggered while the pointer is parked over an arrow
      // (the case where the user clicks Next and the lens used to pop back
      // up on top of the same arrow without any further mouse movement).
      updateLensPosition(lastLensClientX, lastLensClientY);
    }
    function hideLens() {
      if (!lens) return;
      lens.classList.remove('is-active');
    }

    // Arrow safe zone — desktop only. The lens hides when the cursor enters
    // either side strip so the slide arrows can be read and clicked without
    // the magnifier crowding them. Width covers the arrow (max ~44px at the
    // 1.2vw cap) plus padding so the lens disappears BEFORE the user reaches
    // the arrow. Mobile (≤899px) has no arrows, so no safe zone.
    var ARROW_SAFE_ZONE = 80;
    var mqlMobileLens = window.matchMedia('(max-width: 899px)');

    // True 2x magnifier: scale the background image to twice the stage's
    // pixel dimensions, then position it so the point under the cursor (x, y)
    // on the stage appears at the LENS's centre. Math:
    //   bgPosX = lensW/2 − 2·x  (and similarly for Y)
    // At lens-internal coord (lw/2, lh/2), the displayed bg pixel is
    //   (lw/2 − bgPosX) = 2x  → stage pixel x ✓
    // The lens itself is positioned centred on the cursor and clamped to the
    // stage, so when the cursor approaches an edge the lens stops moving but
    // the magnified view still tracks correctly because bg-position keeps
    // using the raw (x, y).
    function updateLensPosition(clientX, clientY) {
      if (!lens || !stage || !lensActive) return;
      var rect = stage.getBoundingClientRect();
      var x = clientX - rect.left;
      var y = clientY - rect.top;

      // Arrow safe zone (desktop only) — hide the lens but KEEP lensActive
      // true so it pops back the moment the cursor leaves the side strip.
      var inSafeZone = !mqlMobileLens.matches && (x < ARROW_SAFE_ZONE || x > rect.width - ARROW_SAFE_ZONE);
      if (inSafeZone) {
        lens.classList.remove('is-active');
        return;
      }
      lens.classList.add('is-active');

      var lw = lens.offsetWidth, lh = lens.offsetHeight;
      // Centre the lens on the cursor, clamped to stage bounds.
      var lx = Math.max(0, Math.min(rect.width - lw, x - lw / 2));
      var ly = Math.max(0, Math.min(rect.height - lh, y - lh / 2));
      lens.style.left = lx + 'px';
      lens.style.top = ly + 'px';

      // True 2x zoom — bg scaled to twice the stage size.
      lens.style.backgroundSize = (rect.width * 2) + 'px ' + (rect.height * 2) + 'px';

      // Cursor area centred in the lens.
      var bgPosX = lw / 2 - 2 * x;
      var bgPosY = lh / 2 - 2 * y;
      lens.style.backgroundPosition = bgPosX + 'px ' + bgPosY + 'px';
    }

    var hasHover = window.matchMedia('(hover: hover)').matches;

    if (stage && hasHover) {
      // Desktop hover-lens — show while the pointer is over the stage, hide
      // on mouseleave. The lens itself has `pointer-events: none` so it
      // doesn't steal mouse events from the underlying stage.
      stage.addEventListener('mouseenter', function (e) {
        lensActive = true;
        lastLensClientX = e.clientX;
        lastLensClientY = e.clientY;
        showLens();
      });
      stage.addEventListener('mouseleave', function () {
        lensActive = false;
        hideLens();
      });
      stage.addEventListener('mousemove', function (e) {
        if (!lensActive) return;
        lastLensClientX = e.clientX;
        lastLensClientY = e.clientY;
        updateLensPosition(e.clientX, e.clientY);
      });
    }

    // Touch handlers on the stage: tap-to-toggle the magnifier, drag to pan
    // it. When the magnifier is INACTIVE, dragging behaves the same as before
    // — direction-locked horizontal swipes advance/rewind the slider. When
    // the magnifier is ACTIVE, dragging pans the lens (no slide change), and
    // any tap (no movement) toggles the lens state.
    (function () {
      if (!stage) return;
      var startX = null, startY = null, lockedAxis = null;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        lockedAxis = null;
      }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (startX === null) return;
        var tx = e.touches[0].clientX, ty = e.touches[0].clientY;
        var dx = tx - startX, dy = ty - startY;
        // Magnifier is on → pan the lens, block the page from scrolling.
        if (lensActive) {
          if (e.cancelable) e.preventDefault();
          lastLensClientX = tx; lastLensClientY = ty;
          updateLensPosition(tx, ty);
          return;
        }
        // Magnifier is off → direction-lock to decide between horizontal
        // swipe-to-navigate and vertical page-scroll (8px deadzone).
        if (lockedAxis === null) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          lockedAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (lockedAxis === 'x' && e.cancelable) e.preventDefault();
      }, { passive: false });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var dx = endX - startX, dy = endY - startY;
        var wasX = lockedAxis === 'x';
        var moved = Math.abs(dx) > 8 || Math.abs(dy) > 8;
        startX = null; startY = null; lockedAxis = null;

        // Tap (no meaningful movement) → toggle the magnifier.
        if (!moved) {
          if (lensActive) {
            lensActive = false;
            hideLens();
          } else {
            lensActive = true;
            lastLensClientX = endX; lastLensClientY = endY;
            showLens();
          }
          return;
        }
        // While the magnifier is on, ignore swipe-to-navigate so the user
        // can pan freely without accidentally changing slides.
        if (lensActive) return;
        if (!wasX || Math.abs(dx) < 50) return;
        goTo(slideIndex + (dx < 0 ? 1 : -1));
      });
    })();

    /* ---- init ---- */
    packs.forEach(function (pack) {
      pack.querySelectorAll('[data-flavor-row]').forEach(function (row) {
        var first = row.querySelector('.pdp-flavor:not([disabled])');
        if (first) first.classList.add('is-active');
      });
    });
    if (packs.length) selectPack(packs[0]);
    setPurchase(state.purchase);
    updatePrices();
    updateMainImage();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-hydraw"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Native px offsets inside the 912px-tall sachet artwork. Top: 145px blank
  // above the sachet + 50px content padding before the first label. Bottom:
  // 100px blank below + 50px before the last label.
  var IMG_NATIVE_H   = 912;
  var TOP_NATIVE_PX  = 145 + 50;
  var BOT_NATIVE_PX  = 100 + 50;

  document.querySelectorAll('.meet').forEach(function (section) {
    var sachet = section.querySelector('.meet__sachet-img');
    var main = section.querySelector('.meet__main');
    if (!sachet || !main) return;

    function publish() {
      var h = sachet.getBoundingClientRect().height;
      if (h <= 0) return;
      main.style.setProperty('--sachet-h', h + 'px');
      // Scale the native offsets to the rendered image height so the callout
      // content area maps to the visible sachet body at any viewport.
      main.style.setProperty('--sachet-top-offset', (h * TOP_NATIVE_PX / IMG_NATIVE_H) + 'px');
      main.style.setProperty('--sachet-bot-offset', (h * BOT_NATIVE_PX / IMG_NATIVE_H) + 'px');
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(publish).observe(sachet);
    } else {
      window.addEventListener('resize', publish);
    }
    if (sachet.tagName === 'IMG' && !sachet.complete) {
      sachet.addEventListener('load', publish);
    }
    publish();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minerals-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mqDesktop = window.matchMedia('(min-width: 900px)');

  function closeRow(row) {
    var btn = row.querySelector('[data-minerals-toggle]');
    var panel = row.querySelector('[data-minerals-panel]');
    if (!panel) return;
    // Pin current rendered height so the transition can interpolate to 0.
    panel.style.maxHeight = panel.scrollHeight + 'px';
    void panel.offsetHeight;
    row.classList.remove('is-open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = '0px';
  }

  document.querySelectorAll('[data-minerals]').forEach(function (section) {
    var allRows = Array.prototype.slice.call(section.querySelectorAll('[data-minerals-row]'));

    allRows.forEach(function (row) {
      var btn = row.querySelector('[data-minerals-toggle]');
      var panel = row.querySelector('[data-minerals-panel]');
      if (!btn || !panel) return;

      function open() {
        // Desktop: close every other open row first (single-open behavior).
        // Mobile: additive — never collapse siblings, so the page doesn't
        // jump around as the visitor explores multiple minerals.
        if (mqDesktop.matches) {
          allRows.forEach(function (other) {
            if (other !== row && other.classList.contains('is-open')) closeRow(other);
          });
        }
        row.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }

      btn.addEventListener('click', function () {
        if (row.classList.contains('is-open')) closeRow(row);
        else open();
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          if (row.classList.contains('is-open')) panel.style.maxHeight = panel.scrollHeight + 'px';
        }).observe(panel.firstElementChild || panel);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myths-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-myths]');
  if (!sections.length) return;

  const mqMobile = window.matchMedia('(max-width: 900px)');

  sections.forEach((sec) => {
    const HOLD_MS  = parseInt(sec.dataset.holdMs, 10) || 1500;
    const TEXT2_MS = parseInt(sec.dataset.text2Ms, 10) || 2000;
    const TEXT3_MS = parseInt(sec.dataset.text3Ms, 10) || 4000;
    const prev   = sec.querySelector('[data-prev]');
    const next   = sec.querySelector('[data-next]');
    const toggle = sec.querySelector('[data-toggle]');
    const track  = sec.querySelector('[data-track]');
    const slides = Array.from(sec.querySelectorAll('.myths__slide'));
    const text2s = sec.querySelectorAll('.myth__text--2');
    const text3s = sec.querySelectorAll('.myth__text--3');
    const fills  = sec.querySelectorAll('.myth__slider-fill');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Three states:  0 = image 1 + label   1 = image 2 + text 2   2 = image 2 + text 3 */
    let state = 0;
    let autoTimer = null;
    let holdTimer = null;

    function animateFill(ms) {
      fills.forEach((f) => {
        f.style.transition = 'none';
        f.style.width = '0%';
        void f.offsetWidth;
        f.style.transition = 'width ' + ms + 'ms linear';
        f.style.width = '100%';
      });
    }

    function render() {
      sec.classList.toggle('is-expanded', state > 0);
      text2s.forEach((t) => t.classList.toggle('is-active', state === 1));
      text3s.forEach((t) => t.classList.toggle('is-active', state === 2));
      if (state > 0) {
        animateFill(state === 1 ? TEXT2_MS : TEXT3_MS);
        // Mobile: mark the currently-visible slide so its bubble opens; on
        // collapse, clear all card markers so nothing lingers.
        if (typeof syncActiveSlide === 'function') syncActiveSlide();
      } else {
        fills.forEach((f) => { f.style.transition = 'none'; f.style.width = '0%'; });
        slides.forEach((s) => s.classList.remove('is-card-expanded'));
      }
    }

    // Auto-cycle between state 1 and state 2 while expanded.
    function scheduleAuto() {
      clearTimeout(autoTimer);
      if (state === 0 || reduce) return;
      autoTimer = setTimeout(() => {
        state = state === 1 ? 2 : 1;
        render();
        scheduleAuto();
      }, state === 1 ? TEXT2_MS : TEXT3_MS);
    }

    // Set the fold state directly (0 collapse, 1 text 2, 2 text 3).
    function setState(s) {
      state = s;
      render();
      scheduleAuto();
    }

    // Swap between text 2 and text 3 (the middle button / desktop arrows).
    function swapText() {
      setState(state === 1 ? 2 : 1);
    }

    /* ---- Mobile slide swiping ---- */
    function slideCenter(s) { return s.offsetLeft + s.offsetWidth / 2; }
    function currentSlide() {
      const viewC = track.scrollLeft + track.clientWidth / 2;
      let best = 0, bestD = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(slideCenter(s) - viewC);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }
    function goSlide(dir) {
      const i = Math.min(slides.length - 1, Math.max(0, currentSlide() + dir));
      const s = slides[i];
      if (s) track.scrollTo({
        left: slideCenter(s) - track.clientWidth / 2,
        behavior: reduce ? 'auto' : 'smooth'
      });
    }

    /* ---- Mobile per-slide expansion ----
       Only the currently-centered slide opens; others stay collapsed. */
    function syncActiveSlide() {
      if (!mqMobile.matches) return;
      if (!sec.classList.contains('is-expanded')) return;
      const activeIdx = currentSlide();
      slides.forEach((s, i) => { s.classList.toggle('is-card-expanded', i === activeIdx); });
    }
    let scrollRaf = null;
    track && track.addEventListener('scroll', () => {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(syncActiveSlide);
    }, { passive: true });
    // Re-evaluate on viewport breakpoint flips so we don't strand .is-card-expanded
    // on the wrong viewport.
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', () => {
      slides.forEach((s) => s.classList.remove('is-card-expanded'));
      syncActiveSlide();
    });

    /* Arrows:  mobile → swipe slides   desktop → swap text 2 ↔ text 3 (loops).
       The middle toggle always swaps text 2 ↔ text 3. */
    prev && prev.addEventListener('click', () => {
      if (mqMobile.matches) goSlide(-1);
      else swapText();
    });
    next && next.addEventListener('click', () => {
      if (mqMobile.matches) goSlide(1);
      else swapText();
    });
    toggle && toggle.addEventListener('click', swapText);

    /* Scroll: once fully in view, hold the image-1 + label fold for HOLD_MS,
       then unfold to state 1. Fold back to 0 on the way out. */
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const fullyIn = entry.intersectionRatio >= 0.9
            || entry.intersectionRect.height >= window.innerHeight * 0.9;
          if (fullyIn) {
            if (state === 0 && !holdTimer) {
              holdTimer = setTimeout(() => {
                holdTimer = null;
                if (state === 0) setState(1);
              }, HOLD_MS);
            }
          } else {
            if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
            if (entry.intersectionRatio < 0.1 && state !== 0) setState(0);
          }
        });
      }, { threshold: [0, 0.1, 0.4, 0.7, 0.9, 1] });
      io.observe(sec);
    } else {
      setState(1);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
/* i18n: {% javascript %} is not Liquid-rendered — translated strings come
   from data-* attributes on the [data-popup] section root. */
function PT(key, fallback) {
  var el = document.querySelector('[data-popup]');
  return (el && el.dataset && el.dataset[key]) || fallback;
}
(function () {
  const root = document.querySelector('[data-popup]');
  if (!root) return;
  const configEl = root.querySelector('[data-popup-config]');
  let CONFIG;
  try { CONFIG = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!CONFIG.variants || !CONFIG.variants.length) return;

  /* ---------- storage helpers (localStorage only, no cookies) ---------- */
  const LS_KEY = 'hydraw_popup_v1';
  function loadState() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}'); } catch (_) { return {}; }
  }
  function saveState(patch) {
    // Mutate the in-memory `state` object in addition to writing localStorage.
    // Without this, code paths that re-read `state` later in the same page
    // load (e.g. widget-triggered `showFull()` after a scratch reveal) see
    // stale data and mis-route the user — they got title + prize with no CTA
    // because `state.scratched` was still undefined in RAM even though
    // localStorage had `scratched: 1`. `state` is `const` but Object.assign
    // mutates in place, so the reference stays live everywhere it's captured.
    Object.assign(state, patch);
    try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (_) {}
    return state;
  }
  const state = loadState();

  /* ---------- session UUID — one per window lifetime ---------- */
  function sessionId() {
    let s = sessionStorage.getItem('hydraw_popup_session');
    if (!s) {
      s = 'p_' + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36));
      sessionStorage.setItem('hydraw_popup_session', s);
    }
    return s;
  }

  /* ---------- variant assignment (50/50 across enabled blocks) ---------- */
  function assignVariant() {
    if (state.variant) {
      const found = CONFIG.variants.find(v => v.key === state.variant);
      if (found) return found;
    }
    const idx = CONFIG.variants.length === 1 ? 0 : (Math.random() < 0.5 ? 0 : 1);
    const v = CONFIG.variants[idx];
    saveState({ variant: v.key });
    return v;
  }

  /* ---------- env ---------- */
  const isMobile  = window.matchMedia('(max-width: 699px)').matches;
  const isPDP     = location.pathname.indexOf('/products/') === 0;
  const utmParams = new URLSearchParams(location.search);
  const utmSource = utmParams.get('utm_source') || null;

  /* ---------- kill switches ---------- */
  // 1) Already submitted within submitDays → never show.
  // 2) Coming from a Klaviyo email → don't ask them to re-subscribe.
  if (state.state === 'submitted') {
    const elapsedDays = (Date.now() - (state.submittedAt || 0)) / 86400000;
    // Use the *current* variant's submit days for the gate (any future
    // variant change won't accidentally shorten the lockout).
    const submittedVariant = CONFIG.variants.find(v => v.key === state.variant) || CONFIG.variants[0];
    if (elapsedDays < submittedVariant.suppress.submitDays) return;
  }
  if (utmSource === 'klaviyo') {
    saveState({ state: 'suppressed', suppressedAt: Date.now() });
    return;
  }
  if (state.state === 'suppressed') return;
  // 3) Don't show on cart/checkout.
  if (location.pathname.indexOf('/cart') === 0 || location.pathname.indexOf('/checkout') === 0) return;

  const variant = assignVariant();

  /* ---------- copy resolver ---------- */
  function resolveCopy() {
    const c = variant.copy;
    const returning = state.popupSeen === 1 && state.state !== 'submitted';
    return {
      title:        returning && c.titleReturning ? c.titleReturning : c.titleNew,
      body:         returning && c.bodyReturning  ? c.bodyReturning  : c.bodyNew,
      claimLabel:   c.claimLabel,
      submitLabel:  c.submitLabel,
      privacyLine:  c.privacyLine,
      tyTitle:      c.tyTitle,
      tyBody:       c.tyBody,
      tyCloseLabel: c.tyCloseLabel,
      widgetLabel:  isMobile && c.widgetLabelMobile ? c.widgetLabelMobile : c.widgetLabel
    };
  }

  /* ---------- tracking ---------- */
  function track(type, extra) {
    if (!CONFIG.trackUrl) return;
    const body = Object.assign({
      type, site: CONFIG.site, session: sessionId(),
      page: location.pathname,
      device: isMobile ? 'mobile' : 'desktop',
      variant: variant.key,
      utm_source: utmSource,
      utm_medium:   utmParams.get('utm_medium')   || null,
      utm_campaign: utmParams.get('utm_campaign') || null,
      utm_content:  utmParams.get('utm_content')  || null,
      utm_term:     utmParams.get('utm_term')     || null,
      referrer: document.referrer || null
    }, extra || {});
    try {
      fetch(CONFIG.trackUrl, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).catch(() => {});
    } catch (_) {}
  }

  /* ---------- DOM refs ---------- */
  const card        = root.querySelector('[data-popup-card]');
  const backdrop    = root.querySelector('[data-popup-backdrop]');
  const titleEl     = root.querySelector('[data-popup-title]');
  const bodyEl      = root.querySelector('[data-popup-body]');
  const submitBtn   = root.querySelector('[data-popup-submit]');
  const privacyEl   = root.querySelector('[data-popup-privacy]');
  const closeBtn    = root.querySelector('[data-popup-close]');
  const form        = root.querySelector('[data-popup-form]');
  const emailIn     = root.querySelector('[data-popup-email]');
  const errEl       = root.querySelector('[data-popup-error]');
  const viewForm    = root.querySelector('[data-popup-view="form"]');
  const viewThanks  = root.querySelector('[data-popup-view="thanks"]');
  const tyTitleEl   = root.querySelector('[data-popup-ty-title]');
  const tyBodyEl    = root.querySelector('[data-popup-ty-body]');
  const tyCloseBtn  = root.querySelector('[data-popup-ty-close]');
  const widget      = root.querySelector('[data-popup-widget]');
  const widgetLabel = root.querySelector('[data-popup-widget-label]');
  const prizeEl       = root.querySelector('[data-popup-prize]');
  const prizeTagEl    = root.querySelector('[data-popup-prize-tag]');
  const prizeAmountEl = root.querySelector('[data-popup-prize-amount]');
  const prizeSubEl    = root.querySelector('[data-popup-prize-subtitle]');
  const claimBtn      = root.querySelector('[data-popup-claim]');
  const scratchCv   = root.querySelector('[data-popup-scratch-canvas]');

  /* ---------- render ---------- */
  function applyCopy() {
    const c = resolveCopy();
    if (titleEl)    titleEl.textContent     = c.title || '';
    if (bodyEl)     bodyEl.innerHTML        = c.body || '';
    if (submitBtn)  submitBtn.textContent   = c.submitLabel || PT('tSubmit','Get my discount');
    if (privacyEl)  privacyEl.textContent   = c.privacyLine || '';
    if (tyTitleEl)  tyTitleEl.textContent   = c.tyTitle || '';
    if (tyBodyEl)   tyBodyEl.innerHTML      = c.tyBody || '';
    if (tyCloseBtn) tyCloseBtn.textContent  = c.tyCloseLabel || '';
    if (widgetLabel)widgetLabel.textContent = c.widgetLabel || '';
    if (prizeTagEl)    prizeTagEl.textContent    = CONFIG.prizeTag    || '';
    if (prizeAmountEl) prizeAmountEl.textContent = CONFIG.prizeAmount || '';
    if (prizeSubEl)    prizeSubEl.textContent    = CONFIG.prizeSubtitle || '';
    if (claimBtn)      claimBtn.textContent      = c.claimLabel || c.submitLabel || 'Atsiimti';
  }
  applyCopy();

  /* ---------- scratch card ----------
     Initialize on first showFull(). The canvas is positioned over .popup__prize
     and is painted with a gray scratch surface + a label. Pointer events erase
     pixels; at ~50% erased the canvas fades out, the form unlocks, and a
     `scratch_revealed` event is emitted. */
  let scratchInited = false;
  function initScratch() {
    if (scratchInited) return;
    scratchInited = true;
    const useScratch = variant.scratch && variant.scratch.enabled && scratchCv;
    if (!useScratch) {
      // Scratch disabled — drop the canvas + hint, advance to the revealed
      // step so the claim CTA is visible immediately.
      if (scratchCv) scratchCv.parentNode.removeChild(scratchCv);
      setFormStep('revealed');
      return;
    }
    const dpr = window.devicePixelRatio || 1;
    // The .popup__prize element gives us layout dimensions; size the canvas to
    // its rect so 1 css-pixel = 1 layout-pixel after the dpr scale.
    const rect = prizeEl.getBoundingClientRect();
    scratchCv.width  = Math.max(1, Math.round(rect.width  * dpr));
    scratchCv.height = Math.max(1, Math.round(rect.height * dpr));
    const ctx = scratchCv.getContext('2d', { willReadFrequently: true });
    ctx.scale(dpr, dpr);

    /* Paint helpers — the foil image is loaded async; the gradient is a
       placeholder so the surface is visible immediately. Once the image
       arrives we repaint (provided the user hasn't started scratching yet,
       to avoid wiping their progress). */
    const label = (variant.scratch.label || PT('tScratch','SCRATCH HERE')).toUpperCase();

    function paintLabel() {
      const fs = Math.max(14, Math.round(rect.width / 12));
      ctx.save();
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = 'rgba(40, 38, 30, 0.6)';
      ctx.font = '600 ' + fs + 'px "Roboto Mono", ui-monospace, monospace';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.shadowColor = 'rgba(255, 255, 255, 0.55)';
      ctx.shadowBlur = 6;
      ctx.fillText(label, rect.width / 2, rect.height / 2);
      ctx.restore();
    }

    function paintGradient() {
      const grad = ctx.createLinearGradient(0, 0, rect.width, rect.height);
      grad.addColorStop(0,    '#cdcab8');
      grad.addColorStop(0.5,  '#aaa794');
      grad.addColorStop(1,    '#cdcab8');
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, rect.width, rect.height);
    }

    function paintImageCover(img) {
      const ar  = img.naturalWidth / img.naturalHeight;
      const cAR = rect.width / rect.height;
      let sx, sy, sw, sh;
      if (ar > cAR) {
        sh = img.naturalHeight; sw = sh * cAR;
        sx = (img.naturalWidth - sw) / 2; sy = 0;
      } else {
        sw = img.naturalWidth;  sh = sw / cAR;
        sx = 0; sy = (img.naturalHeight - sh) / 2;
      }
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, rect.width, rect.height);
    }

    // Placeholder so the user sees the surface immediately.
    paintGradient();
    paintLabel();

    let scratchStarted = false;
    const imgUrl = CONFIG.scratchImageUrl;
    if (imgUrl) {
      const img = new Image();
      // Shopify CDN serves Access-Control-Allow-Origin: * so getImageData()
      // for progress checking won't taint the canvas. If a different host is
      // configured without CORS the image still draws but `checkProgress`
      // will throw — handled silently and progress falls back to 0 (the
      // canvas stays scratchable; just no auto-reveal at 50%).
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        if (scratchStarted) return;
        ctx.save();
        ctx.globalCompositeOperation = 'source-over';
        ctx.clearRect(0, 0, rect.width, rect.height);
        ctx.restore();
        paintImageCover(img);
        paintLabel();
      };
      // onerror → keep the placeholder gradient that's already painted.
      img.src = imgUrl;
    }

    let lastX = null, lastY = null;
    let active = false;
    let revealed = false;
    let progressCheckPending = false;

    function rectAt() { return scratchCv.getBoundingClientRect(); }
    function ptFromEvent(e) {
      const r = rectAt();
      const t = e.touches ? e.touches[0] : e;
      return { x: t.clientX - r.left, y: t.clientY - r.top };
    }

    // Smaller eraser radius + thinner stroke = more strokes needed to clear
    // the foil. Adds a bit of tactile pleasure instead of "tap once and it's
    // done". Combined with the higher 0.65 reveal threshold below, the user
    // has to actually move their finger to earn the prize.
    function erase(x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = '#000';
      if (lastX != null) {
        ctx.strokeStyle = '#000';
        ctx.lineWidth = 22;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(lastX, lastY);
        ctx.lineTo(x, y);
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(x, y, 11, 0, Math.PI * 2);
      ctx.fill();
      lastX = x; lastY = y;
      scheduleProgressCheck();
    }

    function scheduleProgressCheck() {
      if (progressCheckPending || revealed) return;
      progressCheckPending = true;
      setTimeout(checkProgress, 120);
    }
    function checkProgress() {
      progressCheckPending = false;
      if (revealed) return;
      let data;
      try {
        data = ctx.getImageData(0, 0, scratchCv.width, scratchCv.height).data;
      } catch (e) {
        // Canvas tainted (CORS image without proper headers) — can't sample.
        // The user can still finish scratching manually; we just lose the
        // 50%-auto-reveal. Drop a click target so they can advance once
        // they've clearly scratched a chunk.
        return;
      }
      let cleared = 0, total = 0;
      const stride = 4 * 80;
      for (let i = 3; i < data.length; i += stride) {
        total++;
        if (data[i] < 40) cleared++;
      }
      if (total > 0 && cleared / total >= 0.65) revealScratch();
    }

    function revealScratch() {
      if (revealed) return;
      revealed = true;
      scratchCv.classList.add('is-revealed');
      track('scratch_revealed');
      // Persist so a dismiss-then-reopen lands the user on the claim CTA
      // instead of an empty scratch step they can't escape.
      saveState({ scratched: 1 });
      setFormStep('revealed');
      // After the fade-out completes, drop the canvas from layout so touch
      // events fall through to the underlying prize area.
      setTimeout(() => {
        if (scratchCv && scratchCv.parentNode) scratchCv.parentNode.removeChild(scratchCv);
        // Focus the claim button so keyboard users can advance with Enter.
        // Set `data-noring` first so the focus-visible outline is suppressed
        // for this programmatic focus only — Firefox / Safari otherwise flash
        // an ink outline that reads as an unwanted border. The flag clears on
        // the next real keydown so a Tab away+back restores the ring.
        if (claimBtn) {
          claimBtn.setAttribute('data-noring', '1');
          var clearNoRing = function () {
            claimBtn.removeAttribute('data-noring');
            claimBtn.removeEventListener('keydown', clearNoRing);
            claimBtn.removeEventListener('blur', clearNoRing);
          };
          claimBtn.addEventListener('keydown', clearNoRing);
          claimBtn.addEventListener('blur', clearNoRing);
          try { claimBtn.focus({ preventScroll: true }); } catch (_) {}
        }
      }, 620);
    }

    function down(e) { e.preventDefault(); active = true; scratchStarted = true; lastX = null; const p = ptFromEvent(e); erase(p.x, p.y); }
    function move(e) { if (!active) return; e.preventDefault(); const p = ptFromEvent(e); erase(p.x, p.y); }
    function up()    { active = false; lastX = null; lastY = null; }

    scratchCv.addEventListener('mousedown', down);
    scratchCv.addEventListener('mousemove', move);
    document.addEventListener('mouseup', up);
    scratchCv.addEventListener('touchstart', down, { passive: false });
    scratchCv.addEventListener('touchmove',  move, { passive: false });
    scratchCv.addEventListener('touchend',   up);
  }

  /* ---------- show / dismiss / submit / minimize ---------- */
  let machineState = 'dormant';
  let dismissedAt  = 0;
  let engagedSinceDismiss = 0;
  let interval;

  function setState(s) {
    machineState = s;
    root.setAttribute('data-popup-state', s);
    if (card) card.setAttribute('aria-hidden', s === 'shown' || s === 'thanks' ? 'false' : 'true');
  }

  /* Form step helper — toggles the 3-step micro-flow on .popup__view--form.
     "scratch"  → only scratch interactive
     "revealed" → claim CTA visible
     "email"    → email pill + final submit visible, title/body fade */
  function setFormStep(step) {
    if (viewForm) viewForm.setAttribute('data-form-step', step);
  }

  function showFull() {
    // Snap the form to its final step without any child transition — prevents
    // a visible flicker when re-opening from the widget where title/body
    // fade-ins would otherwise race the card's opacity transition.
    viewForm.classList.add('popup__view--snap');

    applyCopy();
    viewForm.hidden = false;
    viewThanks.hidden = true;

    // If the user has already revealed the prize in any prior session, skip
    // the scratch step on re-open. Otherwise the form would be stuck at
    // "scratch" with the canvas already removed from the DOM.
    const alreadyScratched = state.scratched === 1;
    const useScratch = variant.scratch && variant.scratch.enabled && !alreadyScratched;
    setFormStep(useScratch ? 'scratch' : 'revealed');

    setState('shown');
    widget.setAttribute('data-visible', '0');
    track('shown');

    if (useScratch) {
      requestAnimationFrame(() => requestAnimationFrame(initScratch));
    } else {
      if (scratchCv && scratchCv.parentNode) scratchCv.parentNode.removeChild(scratchCv);
    }

    // Drop the snap class after two frames so subsequent step transitions
    // (scratch → revealed → email) animate normally.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      viewForm.classList.remove('popup__view--snap');
    }));
  }

  function showWidget(bounce) {
    widget.removeAttribute('hidden');
    widget.setAttribute('data-visible', '1');
    if (bounce) {
      widget.setAttribute('data-bounce', '1');
      setTimeout(() => widget.removeAttribute('data-bounce'), 800);
    }
  }

  function minimize() {
    setState('minimized');
    showWidget(false);
  }

  function dismiss(method) {
    // After a successful submit the user is in the thanks state. Every close
    // path from there — X button, backdrop, Escape — must route to permanent
    // suppression so we never re-prompt the same person who already gave us
    // their email. Without this, the X button on thanks would minimize to
    // the widget and the user could re-open the form indefinitely.
    if (machineState === 'thanks' || state.state === 'submitted') {
      suppressForever();
      return;
    }
    track('dismissed', { method });
    saveState({ state: 'dismissed', dismissedAt: Date.now(), popupSeen: 1 });
    dismissedAt = Date.now();
    minimize();
  }

  function suppressForever() {
    saveState({ state: 'suppressed', suppressedAt: Date.now() });
    setState('suppressed');
    widget.setAttribute('data-visible', '0');
  }

  function showThanks() {
    viewForm.hidden = true;
    viewThanks.hidden = false;
    setState('thanks');
  }

  /* ---------- Klaviyo on-site identification ----------
     After a successful submit we tell the Klaviyo onsite SDK who this
     browser belongs to. From that moment on, every subsequent event the
     SDK fires (Viewed Product, Added to Cart, Started Checkout, custom
     events…) attributes to the profile we just created — that's what
     "regular events" depends on. The push() queue API works whether the
     klaviyo.js script has finished loading or not. We also push a custom
     event so flows can trigger on "Popup Submitted" specifically. */
  function identifyKlaviyo(email) {
    try {
      window.klaviyo = window.klaviyo || [];
      // Variant lands on the PROFILE as `popup_variant` so segments and flows
      // can split A vs B without needing to look up the original event.
      window.klaviyo.push(['identify', {
        $email: email,
        $source: 'site_popup',
        popup_variant: variant.key
      }]);
      window.klaviyo.push(['track', 'Popup Submitted', {
        variant: variant.key,
        source: 'site_popup',
        page: location.pathname
      }]);
    } catch (_) {}
  }

  /* ---------- email submit → Klaviyo Subscribe API ---------- */
  async function submitEmail(email) {
    // Per-variant list — A and B can route to different Klaviyo flows.
    const listId = variant.klaviyoListId || '';
    if (!CONFIG.klaviyoCompanyId || !listId) {
      // No Klaviyo Subscribe configured — fail soft. Still identify the
      // browser so on-site events attribute even when subscription wasn't
      // possible.
      identifyKlaviyo(email);
      track('submitted');
      saveState({ state: 'submitted', submittedAt: Date.now(), popupSeen: 1, email: email });
      showThanks();
      return;
    }
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          custom_source: 'site_popup'
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    const res = await fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CONFIG.klaviyoCompanyId),
      { method: 'POST', headers: { 'Content-Type': 'application/json', 'Revision': '2024-10-15' }, body: JSON.stringify(payload) }
    );
    if (!res.ok && res.status !== 202) {
      throw new Error('Klaviyo subscribe failed: ' + res.status);
    }
    identifyKlaviyo(email);
    track('submitted');
    saveState({ state: 'submitted', submittedAt: Date.now(), popupSeen: 1, email: email });
    showThanks();
  }

  /* ---------- re-identify on every page load if we already have an email ----
     The klaviyo.js script is loaded fresh on each page, so its profile
     identity is lost between navigations. Re-pushing identify on every load
     keeps on-site events attributed to the profile that submitted earlier. */
  if (state.email) {
    try {
      window.klaviyo = window.klaviyo || [];
      // Re-stamp popup_variant so a profile that was assigned variant A in
      // an earlier session keeps that attribution even if local state shifts.
      window.klaviyo.push(['identify', {
        $email: state.email,
        popup_variant: state.variant || variant.key
      }]);
    } catch (_) {}
  }

  /* ---------- wiring ---------- */
  closeBtn.addEventListener('click', () => dismiss('x'));
  backdrop.addEventListener('click', () => {
    if (machineState === 'shown') dismiss('backdrop');
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && machineState === 'shown') dismiss('esc');
  });

  // Claim CTA → advance from "revealed" to "email" step.
  if (claimBtn) {
    claimBtn.addEventListener('click', () => {
      setFormStep('email');
      // Auto-focus the email after the fade-in completes.
      setTimeout(() => { try { emailIn.focus({ preventScroll: true }); } catch (_) {} }, 360);
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    // The form is only "submittable" in the email step. Any earlier state
    // (Enter key on the email input doesn't apply yet) just no-ops.
    if (viewForm.getAttribute('data-form-step') !== 'email') return;

    const email = (emailIn.value || '').trim();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      errEl.textContent = PT('tInvalidEmail','Please enter a valid email address.');
      errEl.hidden = false;
      return;
    }
    errEl.hidden = true;
    submitBtn.disabled = true;
    try {
      await submitEmail(email);
    } catch (err) {
      errEl.textContent = PT('tSubscribeFailed','Subscription failed. Please try again.');
      errEl.hidden = false;
      submitBtn.disabled = false;
    }
  });

  tyCloseBtn.addEventListener('click', () => {
    suppressForever();
  });

  widget.addEventListener('click', showFull);

  /* ---------- consent-banner gate ---------- */
  // Wait for the Shopify-injected consent banner to be dismissed (or absent).
  // Polls a wide selector net every 250ms with a 10s ceiling — if no banner
  // ever shows up the wait collapses to ~250ms.
  function waitForConsent(cb) {
    const SELECTORS = '[data-tracking-consent], .shopify-cookie-banner, dialog.shopify-consent-banner, [class*="tracking-consent"], [class*="cookie-banner"], [class*="consent-banner"]';
    const start = Date.now();
    let stableTicks = 0;
    const probe = () => {
      const banner = document.querySelector(SELECTORS);
      const visible = banner && banner.offsetParent !== null;
      if (!visible) {
        stableTicks++;
        if (stableTicks >= 2) return cb();  // ~500ms of no banner
      } else {
        stableTicks = 0;
      }
      if (Date.now() - start > 10000) return cb();
      setTimeout(probe, 250);
    };
    probe();
  }

  /* ---------- triggers ---------- */
  function eligibilityDelayS() {
    // Returning PDP visitor who dismissed → fast 15s re-fire.
    if (state.state === 'dismissed' && isPDP) return variant.trigger.pdpRefireS;
    return null;
  }

  function startTriggers() {
    let scrolledEnough = false;
    let scrolledPct = 0;

    function maxScrollPct() {
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      if (max <= 0) return 100;
      return Math.min(100, (window.scrollY / max) * 100);
    }

    function onScroll() {
      scrolledPct = Math.max(scrolledPct, maxScrollPct());
      if (scrolledPct >= variant.trigger.scrollPct) scrolledEnough = true;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const armedAt = Date.now();

    // First-show timer: wait the cookie-banner-buffer ms, then poll for scroll.
    setTimeout(function fire() {
      if (machineState !== 'dormant') return;
      const refireS = eligibilityDelayS();
      const minWaitMs = refireS != null ? refireS * 1000 : 0;
      if (Date.now() - armedAt < minWaitMs) {
        setTimeout(fire, 500);
        return;
      }
      if (scrolledEnough) {
        showFull();
      } else {
        setTimeout(fire, 500);
      }
    }, variant.trigger.cookieWaitMs);
  }

  /* ---------- minimized-state behavior ---------- */
  function startMinimizedBehavior() {
    if (interval) clearInterval(interval);

    let lastMove = Date.now();
    let idleBounced = false;
    let dirChanges = 0;
    let lastScrollY = window.scrollY;
    let lastScrollDir = 0;

    if (!isMobile) {
      // Desktop — exit-intent + idle nudge.
      function onMouseMove(e) {
        lastMove = Date.now();
        idleBounced = false;
        if (machineState !== 'minimized') return;
        // Exit-intent: cursor leaves viewport top with enough engaged time.
        if (e.clientY <= 0) {
          const engagedS = (Date.now() - dismissedAt) / 1000;
          if (engagedS >= variant.trigger.exitIntentEngagedS) {
            window.removeEventListener('mousemove', onMouseMove);
            showFull();
          }
        }
      }
      window.addEventListener('mousemove', onMouseMove);

      // Idle nudge — every 1s check if mousemove stopped for idleNudgeS while
      // the tab is visible. Bounce the widget once per idle period.
      interval = setInterval(() => {
        if (machineState !== 'minimized') return;
        if (document.visibilityState !== 'visible') return;
        if (idleBounced) return;
        if (variant.trigger.idleNudgeS <= 0) return;
        if ((Date.now() - lastMove) / 1000 >= variant.trigger.idleNudgeS) {
          showWidget(true);
          idleBounced = true;
        }
      }, 1000);
    } else {
      // Mobile — re-expand after sustained engagement (≥N scroll-direction
      // changes AND ≥mobileEngagedS seconds since dismissal). Suppressed on PDP
      // (already deep in the funnel).
      if (isPDP) return;
      if (variant.trigger.mobileEngagedS <= 0) return;
      function onScroll() {
        if (machineState !== 'minimized') return;
        const y = window.scrollY;
        const dir = y > lastScrollY ? 1 : (y < lastScrollY ? -1 : 0);
        if (dir !== 0 && dir !== lastScrollDir) {
          dirChanges++;
          lastScrollDir = dir;
        }
        lastScrollY = y;
        const engagedS = (Date.now() - dismissedAt) / 1000;
        if (dirChanges >= variant.trigger.mobileScrollDirs && engagedS >= variant.trigger.mobileEngagedS) {
          window.removeEventListener('scroll', onScroll);
          showFull();
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* ---------- boot ---------- */
  waitForConsent(() => {
    // Honor an already-dismissed session: show widget on arrival, schedule
    // re-expand triggers, no first-show timer.
    if (state.state === 'dismissed') {
      const elapsedDays = (Date.now() - (state.dismissedAt || 0)) / 86400000;
      if (elapsedDays < variant.suppress.dismissDays) {
        dismissedAt = state.dismissedAt || Date.now();
        minimize();
        startMinimizedBehavior();
        return;
      }
      // Past the suppression window — treat as fresh, but keep popupSeen=1.
    }
    startTriggers();
  });

  // After every dismiss, hand off to the minimized behavior loop.
  const origDismiss = dismiss;
  dismiss = function (method) {
    origDismiss(method);
    startMinimizedBehavior();
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* All Judge.me calls proxy through the self-hosted collector — see
     track.alextoolset.com/reviews/{list,submit,upload}. Base URL is a section
     setting so we can point to staging or a different host without a code
     change. */
  var DEFAULT_API_BASE = 'https://track.alextoolset.com';

  function starsSvg(rating, size) {
    size = size || 14;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var cls = i <= rating ? '' : ' class="pd-reviews__star--empty"';
      html += '<svg viewBox="0 0 24 24" width="' + size + '" height="' + size + '"' + cls + ' aria-hidden="true"><path fill="currentColor" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>';
    }
    return html;
  }

  function esc(str) {
    return (str == null ? '' : String(str))
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatName(full) {
    var parts = String(full || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0];
    return parts[0] + ' ' + parts[1].charAt(0).toUpperCase() + '.';
  }

  function formatDate(iso, locale) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      return d.toLocaleDateString(locale || undefined, { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (_) { return ''; }
  }

  function reviewHasMedia(r) {
    return (r.pictures && r.pictures.length > 0) || (r.videos && r.videos.length > 0) || !!r.videoUid;
  }

  /* Judge.me returns pictures as { urls: { original, small, compact, huge }, hidden }.
     Cards want the small crop (~160w) to save bandwidth; lightbox wants the
     original. Videos in the wild have a similar shape. */
  function firstMediaUrl(r) {
    /* Cloudflare Stream video — UID comes straight from the widget API's
       `video_external_ids` (normalized to `videoUid`). Video leads over
       pictures so video reviews show the playable thumb. */
    if (r.videoUid) {
      return {
        type: 'video',
        embed: 'iframe',
        url: 'https://iframe.videodelivery.net/' + r.videoUid,
        thumb: 'https://videodelivery.net/' + r.videoUid + '/thumbnails/thumbnail.jpg?time=1s&height=600'
      };
    }
    if (r.videos && r.videos.length > 0) {
      var v = r.videos[0];
      if (v.hidden) return null;
      var vurls = v.urls || {};
      var vbig = vurls.original || vurls.huge || v.hosted_url || v.url || null;
      if (vbig) return { type: 'video', url: vbig, thumb: vurls.small || vurls.compact || vbig };
    }
    if (r.pictures && r.pictures.length > 0) {
      var p = r.pictures[0];
      if (p.hidden) return null;
      var purls = p.urls || {};
      var pbig = purls.original || purls.huge || p.hosted_url || p.url || null;
      /* Judge.me's `small` is 160w — too tiny for a 200+ px card (blurry).
         Use the original for both card and lightbox; ~120 KB per image is
         fine, and the browser's own resize handles the down-scale cleanly.

         Videos submitted via our upload proxy get stored in Judge.me's
         `pictures[]` because we pass the URL as `picture_urls[]`. Sniff the
         extension to classify. */
      if (pbig) {
        var isVideo = /\.(mp4|mov|webm|m4v)(\?|$)/i.test(pbig);
        return { type: isVideo ? 'video' : 'image', embed: isVideo ? 'file' : null, url: pbig, thumb: pbig };
      }
    }
    /* Cloudflare Stream video via widget-metafield map. Judge.me's public API
       flags videos with `has_published_videos: true` but never returns the URL;
       the widget metafield does (keyed by created_at, since it's UUID-indexed
       and the REST API uses numeric IDs — created_at is the shared join key). */
    if (r.has_published_videos && window.__pdReviewsMediaMap) {
      var key = String(r.created_at || '').replace(/[+Z].*$/, '').slice(0, 19);
      var entry = window.__pdReviewsMediaMap[key];
      if (entry && entry.videoIds && entry.videoIds[0]) {
        var vid = entry.videoIds[0];
        return {
          type: 'video',
          embed: 'iframe',
          url: 'https://iframe.videodelivery.net/' + vid,
          thumb: 'https://videodelivery.net/' + vid + '/thumbnails/thumbnail.jpg?time=1s&height=600'
        };
      }
    }
    return null;
  }

  document.querySelectorAll('[data-pd-reviews]').forEach(function (section) {
    var productId    = section.getAttribute('data-product-id');
    var shopDomain   = section.getAttribute('data-shop-domain');
    var apiBase      = (section.getAttribute('data-api-base') || DEFAULT_API_BASE).replace(/\/$/, '');
    var pageDesktop  = parseInt(section.getAttribute('data-page-size-desktop'), 10) || 20;
    var pageMobile   = parseInt(section.getAttribute('data-page-size-mobile'), 10) || 10;
    var negThreshold = parseInt(section.getAttribute('data-min-rating-negative'), 10) || 3;

    var head       = section.querySelector('.pd-reviews__head');
    var summary    = section.querySelector('[data-pd-reviews-summary]');
    var avgEl      = section.querySelector('[data-pd-reviews-avg]');
    var avgStarsEl = section.querySelector('[data-pd-reviews-avg-stars]');
    var countEl    = section.querySelector('[data-pd-reviews-count]');
    var toolbar    = section.querySelector('[data-pd-reviews-toolbar]');
    var emptyEl    = section.querySelector('[data-pd-reviews-empty]');
    var skeleton   = section.querySelector('[data-pd-reviews-skeleton]');
    var grid       = section.querySelector('[data-pd-reviews-grid]');
    var pagination = section.querySelector('[data-pd-reviews-pagination]');
    var moreBtn    = section.querySelector('[data-pd-reviews-more]');
    var sortSel    = section.querySelector('[data-pd-reviews-sort]');
    var modal      = section.querySelector('[data-pd-reviews-modal]');
    var lightbox   = section.querySelector('[data-pd-reviews-lightbox]');

    var state = {
      allReviews: [],
      filter: 'all',      // 'all' | 'media' | '1'..'5'
      sort: 'featured',
      visibleCount: 0,
      uploads: []
    };

    /* ---------------------- Fetch reviews ---------------------- */
    function pageSize() {
      return window.matchMedia('(max-width: 899px)').matches ? pageMobile : pageDesktop;
    }

    /* Judge.me's `featured` flag exists ONLY on the classic REST API, while
       replies and video UIDs exist ONLY on the widget API. Neither exposes the
       other's id (uuid vs numeric), so we join on a composite of timestamp +
       rating + body prefix. Verified unique across all 48 reviews; timestamp
       alone collides because Judge.me stores many as date-only midnight. */
    function joinKey(ts, body, rating) {
      var txt = String(body || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
      return String(ts || '').slice(0, 19) + '|' + String(rating) + '|' + txt.slice(0, 60);
    }

    /* Normalize a review from Judge.me's WIDGET API (reviews_for_widget) to
       the internal shape the render pipeline expects. This endpoint — the
       same one their Vue widget uses — is the only one that exposes shop
       replies (`reply_content`) and video UIDs (`video_external_ids`,
       Cloudflare Stream); the classic REST API returns neither. */
    function normalizeWidgetReview(r) {
      return {
        id: r.uuid,
        joinKey: joinKey(r.created_at, r.body || r.body_html, r.rating),
        featured: false,
        rating: parseInt(r.rating, 10) || 0,
        created_at: r.created_at,
        reviewer_name: r.reviewer_name || '',
        title: r.title || '',
        body: r.body || String(r.body_html || '').replace(/<[^>]*>/g, ''),
        pictures: (r.pictures_urls || []).map(function (p) { return { urls: p, hidden: false }; }),
        videoUid: (r.video_external_ids && r.video_external_ids[0]) || null,
        reply_content: r.reply_content || '',
        shop_reply_name: r.shop_reply_name || '',
        upvotes_count: r.thumb_up || 0,
        verified: r.verified_buyer ? 'buyer' : 'nothing',
        reviewer_verified: !!r.verified_buyer,
        curated: 'ok',
        hidden: false,
        published: true
      };
    }

    function fetchAllReviews() {
      if (!shopDomain || !productId) {
        showEmpty();
        return;
      }
      var collected = [];

      /* Primary: Judge.me widget API. Public, CORS-open, no token; caps at
         30 per page so we walk `pagination.total_pages`. */
      function fetchWidgetPage(page) {
        var url = 'https://api.judge.me/reviews/reviews_for_widget'
                + '?shop_domain=' + encodeURIComponent(shopDomain)
                + '&platform=shopify'
                + '&product_id=' + encodeURIComponent(productId)
                + '&per_page=30&page=' + page;
        return fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function (data) {
            var items = (data && data.reviews) || [];
            collected = collected.concat(items.map(normalizeWidgetReview));
            var total = (data && data.pagination && data.pagination.total_pages) || 1;
            if (page < total && page < 10) return fetchWidgetPage(page + 1);
          });
      }

      /* Fallback: our collector proxy over the classic REST API (no replies
         or video URLs, but keeps the section alive if the widget API breaks). */
      function fetchProxyPage(page) {
        var url = apiBase + '/reviews/list?'
                + 'shop_domain=' + encodeURIComponent(shopDomain)
                + '&product_id=' + encodeURIComponent(productId)
                + '&per_page=100&page=' + page;
        return fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function (data) {
            var items = (data && data.reviews) || [];
            collected = collected.concat(items);
            if (items.length === 100 && page < 5) return fetchProxyPage(page + 1);
          });
      }

      /* Secondary, non-blocking: the REST proxy carries the `featured` flag
         that the widget API omits. Failure here must not break the section. */
      function markFeatured() {
        if (!apiBase) return Promise.resolve();
        var url = apiBase + '/reviews/list?'
                + 'shop_domain=' + encodeURIComponent(shopDomain)
                + '&product_id=' + encodeURIComponent(productId)
                + '&per_page=100&page=1';
        return fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function (data) {
            var feat = {};
            ((data && data.reviews) || []).forEach(function (r) {
              if (r.featured) feat[joinKey(r.created_at, r.body, r.rating)] = 1;
            });
            collected.forEach(function (r) { if (feat[r.joinKey]) r.featured = true; });
          })
          .catch(function () { /* featured ordering is a nicety, not a requirement */ });
      }

      function next() {
        return fetchWidgetPage(1)
          .then(markFeatured)
          .catch(function () {
            collected = [];
            return fetchProxyPage(1);
          });
      }

      next()
        .then(function () {
          /* Judge.me's admin "Hide" action can flip any of: hidden=true,
             published=false, curated in {'ignored','spam','not_relevant'}.
             Filter on all three so hidden reviews never leak to the storefront. */
          state.allReviews = collected.filter(function (r) {
            if (r.hidden === true) return false;
            if (r.published === false) return false;
            if (r.curated === 'ignored' || r.curated === 'spam' || r.curated === 'not_relevant') return false;
            return true;
          });
          state.visibleCount = pageSize();
          if (skeleton) skeleton.hidden = true;
          updateSummary();
          render();
        })
        .catch(function () {
          if (skeleton) skeleton.hidden = true;
          showEmpty();
        });
    }

    function showEmpty() {
      if (head) head.hidden = true;
      if (grid) grid.hidden = true;
      if (toolbar) toolbar.hidden = true;
      if (pagination) pagination.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      if (summary) summary.hidden = true;
    }

    /* ---------------------- Summary ---------------------- */
    function updateSummary() {
      if (!state.allReviews.length) { showEmpty(); return; }

      if (head) head.hidden = false;
      if (summary) summary.hidden = false;
      if (toolbar) toolbar.hidden = false;
      if (emptyEl) emptyEl.hidden = true;

      var total = state.allReviews.length;
      var sum = state.allReviews.reduce(function (acc, r) { return acc + (r.rating || 0); }, 0);
      var avg = total > 0 ? (sum / total) : 0;

      if (avgEl)   avgEl.textContent = avg.toFixed(1);
      if (countEl) countEl.textContent = total;
      if (avgStarsEl) avgStarsEl.innerHTML = starsSvg(Math.round(avg), 18);

      var buckets = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      state.allReviews.forEach(function (r) { if (buckets[r.rating] != null) buckets[r.rating]++; });
      for (var i = 1; i <= 5; i++) {
        var pct = total > 0 ? (buckets[i] / total * 100) : 0;
        var bar = section.querySelector('[data-pd-reviews-bar="' + i + '"]');
        var cnt = section.querySelector('[data-pd-reviews-bar-count="' + i + '"]');
        if (bar) bar.style.width = pct.toFixed(1) + '%';
        if (cnt) cnt.textContent = buckets[i];
      }
    }

    /* ---------------------- Sort + filter + render ---------------------- */
    function orderedReviews() {
      var list = state.allReviews.slice();

      // Filter
      if (state.filter === 'media') {
        list = list.filter(reviewHasMedia);
      } else if (['1', '2', '3', '4', '5'].indexOf(state.filter) !== -1) {
        var r = parseInt(state.filter, 10);
        list = list.filter(function (rev) { return rev.rating === r; });
      }

      function sortGroup(arr, by) {
        return arr.slice().sort(function (a, b) {
          if (by === 'highest') return (b.rating || 0) - (a.rating || 0);
          if (by === 'lowest')  return (a.rating || 0) - (b.rating || 0);
          if (by === 'helpful') return (b.upvotes_count || 0) - (a.upvotes_count || 0);
          return new Date(b.created_at || 0) - new Date(a.created_at || 0);
        });
      }

      /* Proportional interleave — distributes `b` evenly through `a` while
         preserving each list's internal order. Used by the featured sort so
         text-only reviews mix between media reviews instead of clustering
         in the trailing masonry columns. */
      function interleave(a, b) {
        if (!a.length) return b.slice();
        if (!b.length) return a.slice();
        var out = [], ai = 0, bi = 0;
        while (ai < a.length || bi < b.length) {
          var aFrac = ai / a.length, bFrac = bi / b.length;
          if (ai < a.length && (bi >= b.length || aFrac <= bFrac)) out.push(a[ai++]);
          else out.push(b[bi++]);
        }
        return out;
      }

      /* Non-featured sorts are GLOBAL — no grouping, the label means what it
         says ("Naujausi" = strictly by date). Featured keeps the original
         media-lead + negatives-last shape, but interleaved. */
      if (state.sort !== 'featured') {
        return sortGroup(list, state.sort);
      }

      var featuredGroup = list.filter(function (r) { return r.featured && r.rating >= negThreshold; });
      var mediaGroup    = list.filter(function (r) { return !r.featured && reviewHasMedia(r) && r.rating >= negThreshold; });
      var positiveGroup = list.filter(function (r) { return !r.featured && !reviewHasMedia(r) && r.rating >= negThreshold; });
      var negativeGroup = list.filter(function (r) { return r.rating < negThreshold; });

      /* Judge.me-featured lead. Media then leads a proportional interleave with
         text-only, so media keeps priority without text clustering into the
         trailing masonry columns. */
      return sortGroup(featuredGroup, 'newest')
        .concat(interleave(sortGroup(mediaGroup, 'newest'), sortGroup(positiveGroup, 'newest')))
        .concat(sortGroup(negativeGroup, 'newest'));
    }

    function isVerified(r) {
      /* Judge.me exposes verification via a couple of fields depending on
         plan/version — accept any of the common shapes. */
      return r.verified === 'buyer'
          || r.verified === true
          || r.reviewer_verified === true
          || r.curated === 'ok';
    }

    /* Shop-reply block ("HYDRAW atsakė:" + reply text). `reply_content` is
       shop-authored HTML straight from Judge.me — safe to inject. Label
       template is a section setting with a [name] placeholder. */
    function replyBlockHtml(r) {
      if (!r.reply_content) return '';
      var label = (section.dataset.replyLabel || '[name] replied:')
        .replace('[name]', esc(r.shop_reply_name || 'HYDRAW'));
      return '<div class="pd-reviews__reply">' +
               '<span class="pd-reviews__reply-label">' + label + '</span>' +
               '<div class="pd-reviews__reply-text">' + r.reply_content + '</div>' +
             '</div>';
    }

    function renderCard(r) {
      var media = firstMediaUrl(r);
      var hasMedia = !!media;
      var isNeg = r.rating < negThreshold;
      var classes = ['pd-reviews__card'];
      classes.push(hasMedia ? 'pd-reviews__card--media' : 'pd-reviews__card--text');
      if (isNeg) classes.push('pd-reviews__card--negative');

      var mediaHtml = '';
      if (hasMedia) {
        var cardSrc = media.thumb || media.url;
        mediaHtml = '<div class="pd-reviews__card-media">';
        if (media.type === 'image') {
          mediaHtml += '<img class="pd-reviews__card-img" src="' + esc(cardSrc) + '" alt="" loading="lazy">';
        } else if (media.embed === 'iframe') {
          /* Cloudflare Stream poster — <img>, not <video>. */
          mediaHtml += '<img class="pd-reviews__card-img" src="' + esc(cardSrc) + '" alt="" loading="lazy">';
          mediaHtml += '<span class="pd-reviews__card-play" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>';
        } else {
          mediaHtml += '<video class="pd-reviews__card-img" src="' + esc(cardSrc) + '" muted playsinline preload="metadata"></video>';
          mediaHtml += '<span class="pd-reviews__card-play" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>';
        }
        mediaHtml += '</div>';
      }

      var titleHtml = r.title ? '<h4 class="pd-reviews__card-title">' + esc(r.title) + '</h4>' : '';
      var bodyHtml = r.body ? '<p class="pd-reviews__card-text">' + esc(r.body).replace(/\n/g, '<br>') + '</p>' : '';

      /* Green-pill verified badge — matches the Judge.me look elsewhere on
         the store. Icon is a filled tick disc; text pulled from a section
         setting so it can be translated. */
      var verifiedHtml = '';
      if (isVerified(r)) {
        /* Icon-only starburst tick next to the name — the "Patvirtintas"
           label lives in aria-label/title, not visible text. */
        verifiedHtml =
          '<span class="pd-reviews__card-verified" role="img" aria-label="' + esc(section.dataset.verifiedLabel || 'Patvirtintas') + '" title="' + esc(section.dataset.verifiedLabel || 'Patvirtintas') + '">' +
            '<span class="pd-reviews__card-verified-icon" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
                '<path fill="currentColor" d="M12 1.5l1.85 2.5 3.05-.55.9 2.95 2.95.9-.55 3.05 2.5 1.85-2.5 1.85.55 3.05-2.95.9-.9 2.95-3.05-.55L12 22.5l-1.85-2.5-3.05.55-.9-2.95-2.95-.9.55-3.05L1.3 12l2.5-1.85-.55-3.05 2.95-.9.9-2.95 3.05.55L12 1.5z"/>' +
                '<path fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="M7.5 12l3 3 6-6"/>' +
              '</svg>' +
            '</span>' +
          '</span>';
      }

      /* Read-more button — shown when body is long enough that it clearly
         gets truncated by our line-clamp. Threshold is generous so we don't
         show a "read more" on a 12-word review. */
      var showReadMore = r.body && r.body.length > 160;
      var readMoreHtml = showReadMore
        ? '<button type="button" class="pd-reviews__card-readmore" data-pd-reviews-readmore>' +
            esc(section.dataset.readMoreLabel || 'Skaityti daugiau') +
            '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h10"/><path d="M9 4l4 4-4 4"/></svg>' +
          '</button>'
        : '';

      /* Judge.me nests the name: `reviewer.name` on API reads; the flat
         `reviewer_name` only exists on widget-metafield entries. */
      var authorName = formatName((r.reviewer && r.reviewer.name) || r.reviewer_name || '');
      var date = formatDate(r.created_at, document.documentElement.lang);

      var card = document.createElement('article');
      card.className = classes.join(' ');
      card.setAttribute('data-review-id', r.id || '');
      card.innerHTML =
        mediaHtml +
        '<div class="pd-reviews__card-body">' +
          '<div class="pd-reviews__card-author-row">' +
            '<span class="pd-reviews__card-author">' + esc(authorName) + '</span>' +
            verifiedHtml +
          '</div>' +
          '<div class="pd-reviews__card-rating-row">' +
            '<div class="pd-reviews__card-stars" aria-label="' + r.rating + ' / 5">' + starsSvg(r.rating || 0, 14) + '</div>' +
          '</div>' +
          titleHtml +
          bodyHtml +
          readMoreHtml +
          replyBlockHtml(r) +
          '<div class="pd-reviews__card-meta">' +
            (date ? '<span class="pd-reviews__card-date">' + esc(date) + '</span>' : '') +
          '</div>' +
        '</div>';

      /* Whole card is clickable — opens the lightbox with the full review.
         Works for text-only reviews (openLightbox handles null media). */
      card.addEventListener('click', function (e) {
        /* Let inner buttons (e.g. read-more) trigger the same handler
           without double-firing; nothing to stop-propagate. */
        openLightbox(r, media);
      });
      return card;
    }

    function render() {
      var ordered = orderedReviews();
      grid.hidden = ordered.length === 0;
      grid.innerHTML = '';
      var toShow = ordered.slice(0, state.visibleCount);
      toShow.forEach(function (r) { grid.appendChild(renderCard(r)); });

      if (pagination) pagination.hidden = ordered.length <= state.visibleCount;

      /* The read-more button renders on a character-count guess (>160 chars),
         but the CSS clamp is line-based (4 lines, 7 on text-only cards) — a
         mid-length review can fit entirely yet still get the button. After
         layout, measure the real overflow and hide the button when the text
         isn't actually clipped. */
      requestAnimationFrame(function () {
        grid.querySelectorAll('.pd-reviews__card').forEach(function (card) {
          var txt = card.querySelector('.pd-reviews__card-text');
          var btn = card.querySelector('[data-pd-reviews-readmore]');
          if (!txt || !btn) return;
          if (txt.scrollHeight <= txt.clientHeight + 2) btn.hidden = true;
        });
      });
    }

    /* ---------------------- Lightbox ----------------------
       Media argument is optional. When present → media on the left, body on
       the right (desktop); stacked on mobile. When null → text-only view
       with a slightly wider body pane. */
    function openLightbox(review, media) {
      if (!lightbox) return;
      var mediaHtml = '';
      if (media) {
        var lbInner;
        if (media.type === 'image') {
          lbInner = '<img src="' + esc(media.url) + '" alt="">';
        } else if (media.embed === 'iframe') {
          lbInner = '<iframe class="pd-reviews__lightbox-iframe" src="' + esc(media.url) + '?autoplay=true" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowfullscreen loading="lazy"></iframe>';
        } else {
          lbInner = '<video src="' + esc(media.url) + '" controls autoplay playsinline></video>';
        }
        mediaHtml = '<div class="pd-reviews__lightbox-media">' + lbInner + '</div>';
      }
      var name = esc(formatName((review.reviewer && review.reviewer.name) || review.reviewer_name || ''));
      var date = esc(formatDate(review.created_at, document.documentElement.lang));
      var title = review.title ? '<h3 class="pd-reviews__lightbox-title">' + esc(review.title) + '</h3>' : '';
      var body = review.body ? '<p class="pd-reviews__lightbox-text">' + esc(review.body) + '</p>' : '';
      var verified = isVerified(review)
        ? '<span class="pd-reviews__card-verified" role="img" aria-label="' + esc(section.dataset.verifiedLabel || 'Patvirtintas') + '" title="' + esc(section.dataset.verifiedLabel || 'Patvirtintas') + '">' +
            '<span class="pd-reviews__card-verified-icon" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
                '<path fill="currentColor" d="M12 1.5l1.85 2.5 3.05-.55.9 2.95 2.95.9-.55 3.05 2.5 1.85-2.5 1.85.55 3.05-2.95.9-.9 2.95-3.05-.55L12 22.5l-1.85-2.5-3.05.55-.9-2.95-2.95-.9.55-3.05L1.3 12l2.5-1.85-.55-3.05 2.95-.9.9-2.95 3.05.55L12 1.5z"/>' +
                '<path fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="M7.5 12l3 3 6-6"/>' +
              '</svg>' +
            '</span>' +
          '</span>'
        : '';

      var inner = lightbox.querySelector('[data-pd-reviews-lightbox-inner]');
      inner.classList.toggle('pd-reviews__lightbox-inner--text-only', !media);
      inner.innerHTML =
        mediaHtml +
        '<div class="pd-reviews__lightbox-body">' +
          '<div class="pd-reviews__card-author-row">' +
            '<span class="pd-reviews__card-author">' + name + '</span>' +
            verified +
          '</div>' +
          '<div class="pd-reviews__card-rating-row">' +
            '<div class="pd-reviews__card-stars">' + starsSvg(review.rating || 0, 18) + '</div>' +
          '</div>' +
          title + body +
          replyBlockHtml(review) +
          '<div class="pd-reviews__lightbox-meta">' +
            (date ? '<span class="pd-reviews__card-date">' + date + '</span>' : '') +
          '</div>' +
        '</div>';

      openDialog(lightbox);
    }

    /* ---------------------- Modal helpers ---------------------- */
    function openDialog(dlg) {
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
      document.body.classList.add('pd-reviews-modal-open');
    }
    function closeDialog(dlg) {
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
      document.body.classList.remove('pd-reviews-modal-open');
    }

    /* ---------------------- Star input ---------------------- */
    var starButtons = section.querySelectorAll('[data-pd-reviews-stars] [data-value]');
    var currentRating = 5;
    function setRating(v) {
      currentRating = v;
      starButtons.forEach(function (b) {
        var val = parseInt(b.getAttribute('data-value'), 10);
        b.classList.toggle('is-active', val <= v);
        b.setAttribute('aria-checked', val === v ? 'true' : 'false');
      });
    }
    setRating(5);
    starButtons.forEach(function (b) {
      b.addEventListener('click', function () { setRating(parseInt(b.getAttribute('data-value'), 10)); });
    });

    /* ---------------------- Media upload ---------------------- */
    var fileInput   = section.querySelector('[data-pd-reviews-file-input]');
    var uploadPrev  = section.querySelector('[data-pd-reviews-upload-preview]');

    function addUploadPlaceholder(file) {
      var thumb = document.createElement('div');
      thumb.className = 'pd-reviews__upload-thumb is-uploading';
      var isVideo = file.type.indexOf('video/') === 0;
      var reader = new FileReader();
      reader.onload = function (e) {
        thumb.innerHTML =
          (isVideo
            ? '<video src="' + e.target.result + '" muted playsinline></video>'
            : '<img src="' + e.target.result + '" alt="">') +
          '<button type="button" class="pd-reviews__upload-remove" aria-label="Remove">×</button>';
        thumb.querySelector('.pd-reviews__upload-remove').addEventListener('click', function () {
          var idx = state.uploads.indexOf(entry);
          if (idx >= 0) state.uploads.splice(idx, 1);
          thumb.remove();
        });
      };
      reader.readAsDataURL(file);
      uploadPrev.appendChild(thumb);

      var entry = { file: file, url: null, type: isVideo ? 'video' : 'image', thumb: thumb };
      state.uploads.push(entry);
      return entry;
    }

    function uploadFile(entry) {
      var form = new FormData();
      form.append('file', entry.file);
      form.append('shop_domain', shopDomain);

      return fetch(apiBase + '/reviews/upload', {
        method: 'POST',
        body: form
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (data) {
          entry.url = (data && (data.url || data.picture_url)) || null;
          entry.thumb.classList.remove('is-uploading');
          if (!entry.url) entry.thumb.classList.add('is-error');
        })
        .catch(function () {
          entry.thumb.classList.remove('is-uploading');
          entry.thumb.classList.add('is-error');
        });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        Array.prototype.forEach.call(fileInput.files, function (file) {
          var entry = addUploadPlaceholder(file);
          uploadFile(entry);
        });
        fileInput.value = '';
      });
    }

    /* ---------------------- Submit ---------------------- */
    var form = section.querySelector('[data-pd-reviews-form]');
    var statusEl = section.querySelector('[data-pd-reviews-status]');
    var submitBtn = section.querySelector('[data-pd-reviews-submit]');
    var submitLabel = section.querySelector('[data-pd-reviews-submit-label]');

    function setStatus(msg, mode) {
      if (!statusEl) return;
      statusEl.hidden = !msg;
      statusEl.textContent = msg || '';
      statusEl.className = 'pd-reviews__status' + (mode ? ' is-' + mode : '');
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        setStatus('');
        var data = new FormData(form);
        var name = data.get('name');
        var email = data.get('email');
        var title = data.get('title');
        var body  = data.get('body');
        if (!name || !email || !body) {
          setStatus(section.dataset.msgValidation || 'Please complete all fields.', 'error');
          return;
        }

        var pending = state.uploads.filter(function (u) { return u.file && !u.url && !u.thumb.classList.contains('is-error'); });
        if (pending.length > 0) {
          setStatus(section.dataset.msgUploading || 'Please wait for uploads to finish.', 'error');
          return;
        }

        submitBtn.disabled = true;
        var origLabel = submitLabel ? submitLabel.textContent : '';
        if (submitLabel) submitLabel.textContent = section.dataset.msgSending || 'Sending…';

        var params = new URLSearchParams();
        params.append('shop_domain', shopDomain);
        params.append('id', productId);
        params.append('name', name);
        params.append('email', email);
        params.append('rating', currentRating);
        if (title) params.append('title', title);
        params.append('body', body);
        state.uploads.forEach(function (u) {
          if (u.url) params.append('picture_urls[]', u.url);
        });

        fetch(apiBase + '/reviews/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params.toString()
        })
          .then(function (r) {
            if (!r.ok) throw new Error('submit_failed');
            setStatus(section.dataset.msgSuccess || 'Thanks! Your review is being processed.', 'success');
            setTimeout(function () {
              closeDialog(modal);
              form.reset();
              setRating(5);
              state.uploads = [];
              if (uploadPrev) uploadPrev.innerHTML = '';
              setStatus('');
              submitBtn.disabled = false;
              if (submitLabel) submitLabel.textContent = origLabel;
            }, 2200);
          })
          .catch(function () {
            setStatus(section.dataset.msgError || 'Something went wrong.', 'error');
            submitBtn.disabled = false;
            if (submitLabel) submitLabel.textContent = origLabel;
          });
      });
    }

    /* ---------------------- Judge.me native popup — trigger from app block ---
       The Vue-based Judge.me app block on the product page renders a
       `[data-testid="write-review-button"]` that opens their proper modal
       (with rating stars, media upload, everything). We keep that block
       clipped off-screen via CSS and just click its button when the user
       hits our "Palikti atsiliepimą" CTA. The modal itself is Vue-teleported
       to `document.body`, so hiding the app block doesn't affect it. */
    function triggerJdgmPopup() {
      var start = Date.now();
      var tick = function () {
        var btn = document.querySelector('[data-testid="write-review-button"]');
        if (btn) {
          btn.click();
          return;
        }
        if (Date.now() - start < 5000) return setTimeout(tick, 120);
        console.warn('[pd-reviews] Judge.me write-review button not found — is the app block added to the product page?');
      };
      tick();
    }

    section.querySelectorAll('[data-pd-reviews-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        triggerJdgmPopup();
      });
    });

    /* If the URL has Judge.me's review-request magic-link token, ensure the
       popup opens even if their own auto-open gets confused by us clipping
       their widget off-screen. Their core script still does the token→prefill
       API call regardless of the widget's visibility, so name/email land in
       the form correctly. We just guarantee the popup surfaces. */
    (function () {
      try {
        var params = new URLSearchParams(window.location.search);
        if (!params.get('judgeme_token')) return;
        /* Their script needs a moment to hydrate + resolve the token. Trigger
           once we see the button exists, up to 6s. */
        var start = Date.now();
        var tick = function () {
          if (document.querySelector('[data-testid="write-review-button"]')) {
            triggerJdgmPopup();
            return;
          }
          if (Date.now() - start < 6000) setTimeout(tick, 150);
        };
        tick();
      } catch (_) {}
    })();

    /* ---------------------- Legacy modal close-only wiring ----------------
       The submit modal (`data-pd-reviews-modal`) is no longer opened — the
       write CTA triggers Judge.me's native Vue popup instead (above). We keep
       these close handlers as safe no-ops in case the DOM is ever surfaced. */
    section.querySelectorAll('[data-pd-reviews-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeDialog(modal); });
    });
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) closeDialog(modal); });
      modal.addEventListener('close', function () { document.body.classList.remove('pd-reviews-modal-open'); });
    }

    if (lightbox) {
      section.querySelectorAll('[data-pd-reviews-lightbox-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { closeDialog(lightbox); });
      });
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeDialog(lightbox); });
      lightbox.addEventListener('close', function () { document.body.classList.remove('pd-reviews-modal-open'); });
    }

    /* ---------------------- Summary popover toggle ---------------------- */
    var summaryToggle  = section.querySelector('[data-pd-reviews-summary-toggle]');
    var summaryDetails = section.querySelector('[data-pd-reviews-summary-details]');
    if (summaryToggle && summaryDetails) {
      summaryToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = summaryToggle.getAttribute('aria-expanded') === 'true';
        summaryToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        summaryDetails.hidden = open;
      });
      /* Close on outside click / ESC — matches other popovers on the site. */
      document.addEventListener('click', function (e) {
        if (summaryToggle.getAttribute('aria-expanded') !== 'true') return;
        if (summaryDetails.contains(e.target) || summaryToggle.contains(e.target)) return;
        summaryToggle.setAttribute('aria-expanded', 'false');
        summaryDetails.hidden = true;
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && summaryToggle.getAttribute('aria-expanded') === 'true') {
          summaryToggle.setAttribute('aria-expanded', 'false');
          summaryDetails.hidden = true;
        }
      });
    }

    /* ---------------------- Filters + sort + more ---------------------- */
    section.querySelectorAll('[data-pd-reviews-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-pd-reviews-filter');
        // If already active, unset back to all
        if (state.filter === val) val = 'all';
        state.filter = val;
        section.querySelectorAll('[data-pd-reviews-filter]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-pd-reviews-filter') === state.filter);
        });
        state.visibleCount = pageSize();
        render();
      });
    });
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        state.sort = sortSel.value;
        state.visibleCount = pageSize();
        render();
      });
    }
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.visibleCount += pageSize();
        render();
      });
    }

    /* ---------------------- Prefill from hidden Judge.me widget ---------------------- */
    var jdgmRoot = document.getElementById('judgeme_product_reviews');
    if (jdgmRoot) {
      var tried = false;
      var tryPrefill = function () {
        var jName  = jdgmRoot.querySelector('input[name="reviewer_name"]');
        var jEmail = jdgmRoot.querySelector('input[name="reviewer_email"]');
        if (!jName || !jEmail || !jEmail.value) return false;
        var nameInput = form && form.querySelector('input[name="name"]');
        var emailInput = form && form.querySelector('input[name="email"]');
        if (nameInput)  nameInput.value  = jName.value;
        if (emailInput) emailInput.value = jEmail.value;
        if (!tried) {
          tried = true;
          openDialog(modal);
        }
        return true;
      };
      if (!tryPrefill()) {
        var obs = new MutationObserver(function () { if (tryPrefill()) obs.disconnect(); });
        obs.observe(jdgmRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        setTimeout(function () { obs.disconnect(); }, 8000);
      }
    }

    /* ---------------------- Boot ---------------------- */
    fetchAllReviews();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
/* Modal open/close + mobile progress bar. Progress logic mirrors the
   scenarios section so cadence feels identical across the product page. */
(function () {
  var MIN_PCT = 18;

  document.querySelectorAll('[data-pd-testi]').forEach(function (section) {
    /* ---- Modal open / close ---------------------------------------- */
    var modal = section.querySelector('[data-pd-testi-modal]');
    var modalInner = section.querySelector('[data-pd-testi-modal-inner]');

    function openModal(blockId) {
      if (!modal || !modalInner) return;
      var tpl = section.querySelector('template[data-pd-testi-full="' + blockId + '"]');
      if (!tpl) return;
      modalInner.innerHTML = '';
      modalInner.appendChild(tpl.content.cloneNode(true));
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.body.classList.add('pd-testi-modal-open');
    }

    function closeModal() {
      if (!modal) return;
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      document.body.classList.remove('pd-testi-modal-open');
      if (modalInner) modalInner.innerHTML = '';
    }

    section.querySelectorAll('[data-pd-testi-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-pd-testi-open'));
      });
    });

    if (modal) {
      var closeBtn = section.querySelector('[data-pd-testi-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      /* Backdrop click — <dialog>'s click bubbles from the backdrop as an
         event targeting the dialog itself; the inner card catches its own
         clicks, so a click whose target is the <dialog> means backdrop. */
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
      /* Native <dialog> emits `close` on ESC and .close() — sync the body
         class in case it was set some other way. */
      modal.addEventListener('close', function () {
        document.body.classList.remove('pd-testi-modal-open');
        if (modalInner) modalInner.innerHTML = '';
      });
    }

    /* ---- Mobile scroll progress ----------------------------------- */
    var track = section.querySelector('[data-pd-testi-track]');
    var fill  = section.querySelector('[data-pd-testi-progress-fill]');
    if (!track || !fill) return;

    var mqDesktop = window.matchMedia('(min-width: 900px)');

    function updateProgress() {
      if (mqDesktop.matches) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var pct = maxScroll > 0 ? (track.scrollLeft / maxScroll) * 100 : 0;
      pct = Math.max(0, Math.min(100, pct));
      fill.style.width = (MIN_PCT + (100 - MIN_PCT) * (pct / 100)) + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', updateProgress);
    updateProgress();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["research-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-rtabs]').forEach(function (section) {
    var nav = section.querySelector('.rtabs__nav');
    var panelsWrap = section.querySelector('.rtabs__panels');
    var tabs = section.querySelectorAll('[data-rtabs-tab]');
    var panels = section.querySelectorAll('[data-rtabs-panel]');
    if (!tabs.length || !panels.length) return;

    var mqMobile = window.matchMedia('(max-width: 700px)');
    var prevIdx = 0;
    var activeIdx = 0;

    // On mobile, slide the scrollable tab bar so the *next* tab peeks when
    // moving forward, and the *previous* tab peeks when moving backward —
    // symmetric so the user always sees the direction they could go next.
    function scrollNavTo(i, backward) {
      if (!mqMobile.matches || !nav) return;
      var tab = tabs[i];
      if (!tab) return;
      var navWidth = nav.clientWidth;
      var target;
      if (backward) {
        // Active tab's RIGHT edge ~82% from nav's left → earlier tab peeks left.
        target = tab.offsetLeft + tab.clientWidth - navWidth * 0.82;
      } else {
        // Active tab's LEFT edge ~18% from nav's left → next tab peeks right.
        target = tab.offsetLeft - navWidth * 0.18;
      }
      var maxScroll = nav.scrollWidth - navWidth;
      target = Math.max(0, Math.min(maxScroll, target));
      nav.scrollTo({ left: target, behavior: 'smooth' });
    }

    function activate(i) {
      var backward = i < prevIdx;
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      scrollNavTo(i, backward);
      prevIdx = i;
      activeIdx = i;
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i); });
      t.addEventListener('mouseenter', function () { activate(i); });
    });

    /* ---- Mobile swipe — advances to next/previous tab on horizontal drag.
       Direction-locking: once we detect horizontal intent in touchmove, we
       preventDefault so the page doesn't scroll vertically while the user is
       swiping a not-perfectly-straight gesture. Vertical-intent gestures are
       released back to the page scroller. ---- */
    if (panelsWrap) {
      var startX = null, startY = null, lockedAxis = null;

      panelsWrap.addEventListener('touchstart', function (e) {
        if (!mqMobile.matches) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        lockedAxis = null;
      }, { passive: true });

      panelsWrap.addEventListener('touchmove', function (e) {
        if (!mqMobile.matches || startX === null) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        // Resolve axis on first meaningful movement. 8px deadzone tolerates
        // accidental jitter at the start of the gesture.
        if (lockedAxis === null) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          lockedAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        // If the gesture is horizontal, block vertical scroll for the rest of
        // this gesture. If it's vertical, do nothing — let the page scroll.
        if (lockedAxis === 'x' && e.cancelable) e.preventDefault();
      }, { passive: false });

      panelsWrap.addEventListener('touchend', function (e) {
        if (!mqMobile.matches || startX === null) return;
        var endX = e.changedTouches[0].clientX;
        var dx = endX - startX;
        var wasX = lockedAxis === 'x';
        startX = null; startY = null; lockedAxis = null;
        if (!wasX || Math.abs(dx) < 50) return;
        if (dx < 0 && activeIdx < tabs.length - 1) activate(activeIdx + 1);
        else if (dx > 0 && activeIdx > 0) activate(activeIdx - 1);
      }, { passive: true });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scenarios"] && !Shopify.designMode) return;
  try {
    
(function () {
  const MIN_PCT = 18;
  document.querySelectorAll('[data-scenarios]').forEach(function (section) {
    var track = section.querySelector('[data-scenarios-track]');
    var fill = section.querySelector('[data-scenarios-progress-fill]');
    if (!track || !fill) return;

    var mqDesktop = window.matchMedia('(min-width: 700px)');

    function updateProgress() {
      if (mqDesktop.matches) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var pct = maxScroll > 0 ? (track.scrollLeft / maxScroll) * 100 : 0;
      pct = Math.max(0, Math.min(100, pct));
      fill.style.width = (MIN_PCT + (100 - MIN_PCT) * (pct / 100)) + '%';
    }

    var pristine = true;
    function markInteracted() { pristine = false; }
    track.addEventListener('pointerdown', markInteracted, { passive: true });
    track.addEventListener('touchstart', markInteracted, { passive: true });
    track.addEventListener('wheel', markInteracted, { passive: true });

    function resetIfPristine() {
      if (!pristine) return;
      if (mqDesktop.matches) return;
      track.scrollLeft = 0;
      updateProgress();
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', updateProgress);
    updateProgress();
    resetIfPristine();
    if (document.readyState === 'complete') {
      requestAnimationFrame(resetIfPristine);
    } else {
      window.addEventListener('load', function () { requestAnimationFrame(resetIfPristine); }, { once: true });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            resetIfPristine();
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '50% 0px' });
      io.observe(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-expand"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-expand]');
  if (!sections.length) return;

  // Measure the tallest natural inner height in a section, then publish it as a CSS variable.
  // CSS uses --max-body-h for both the inner's min-height and the wrapper's expanded height,
  // so all cards render uniform AND tight to the longest text — no fixed-height padding excess.
  function syncMax(section) {
    const inners = Array.from(section.querySelectorAll('.expand__body-inner'));
    if (!inners.length) return;
    // Force min-height to 0 during measurement so each inner reports its true text-driven
    // natural height (otherwise the CSS fallback min-height would dominate the read).
    const originals = inners.map((el) => el.style.minHeight);
    inners.forEach((el) => { el.style.minHeight = '0px'; });
    section.style.removeProperty('--max-body-h');
    void inners[0].offsetHeight; // commit the reset before reading

    // Use getBoundingClientRect().height (fractional) + Math.ceil so subpixel
    // rendered heights round UP — `offsetHeight` truncates the fraction, which
    // left the inner's 1px bottom border sitting at/below the wrapper's
    // `overflow: hidden` clip line on viewports/DPRs where the fraction landed
    // unfavourably. The extra +1 is a belt-and-braces safety pixel for late
    // font swaps and zoom-level rounding.
    let max = 0;
    inners.forEach((el) => {
      const h = Math.ceil(el.getBoundingClientRect().height);
      if (h > max) max = h;
    });

    // Restore inline min-height (CSS rule will resolve via the freshly-set --max-body-h).
    inners.forEach((el, i) => { el.style.minHeight = originals[i] || ''; });
    section.style.setProperty('--max-body-h', (max + 1) + 'px');
  }

  // Publish on initial load.
  const syncAll = () => sections.forEach(syncMax);
  syncAll();

  // Re-publish on resize (clamp values change). rAF-throttled.
  let resizeRaf;
  window.addEventListener('resize', () => {
    if (resizeRaf) cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(syncAll);
  }, { passive: true });

  // Re-publish once webfonts have loaded. The body copy is Roboto Mono; a
  // fallback font wraps to fewer lines, so a measure taken too early under-sizes
  // the tallest card and its bottom border gets clipped on expand.
  if (document.fonts) {
    document.fonts.ready.then(syncAll);
    if (document.fonts.load) {
      document.fonts.load('400 1rem "Roboto Mono"').then(syncAll).catch(function () {});
    }
  }

  // Bulletproof: re-publish whenever the body copy actually reflows (font swap,
  // late layout shifts). Observing the text element — not the inner that syncMax
  // mutates — avoids a measure/observe feedback loop.
  if ('ResizeObserver' in window) {
    let roRaf;
    const ro = new ResizeObserver(() => {
      if (roRaf) cancelAnimationFrame(roRaf);
      roRaf = requestAnimationFrame(syncAll);
    });
    sections.forEach((s) => {
      s.querySelectorAll('.expand__text, .expand__heading').forEach((t) => ro.observe(t));
    });
  }

  // ---- Mobile per-card expansion ----
  // On mobile the track scrolls horizontally. The card whose center is closest
  // to the track's visible center gets `.is-card-expanded` ADDED — we never
  // remove it from previously-active cards, so once a card has been swiped
  // into view it stays open. Keeps the section's height stable as the user
  // swipes (no collapse → no section-below "jump up").
  const mqMobile = window.matchMedia('(max-width: 1100px)');
  function syncActiveCard(section) {
    if (!mqMobile.matches) return;
    if (!section.classList.contains('is-expanded')) return;
    const track = section.querySelector('.expand__track');
    const cards = section.querySelectorAll('.expand__card');
    if (!track || !cards.length) return;
    const trackRect = track.getBoundingClientRect();
    cards.forEach(function (card) {
      const r = card.getBoundingClientRect();
      const visibleLeft = Math.max(r.left, trackRect.left);
      const visibleRight = Math.min(r.right, trackRect.right);
      const visibleWidth = Math.max(0, visibleRight - visibleLeft);
      if (visibleWidth >= r.width * 0.3) {
        card.classList.add('is-card-expanded');
      }
    });
  }

  // Progress pill — width grows from a minimum nub at scroll 0% to 100% at
  // max scroll. Only meaningful on mobile (pill is display:none on desktop).
  const PROGRESS_MIN_PCT = 18;
  function syncProgress(section) {
    const track = section.querySelector('.expand__track');
    const fill = section.querySelector('[data-expand-progress-fill]');
    if (!track || !fill) return;
    const maxScroll = track.scrollWidth - track.clientWidth;
    let pct = maxScroll > 0 ? (track.scrollLeft / maxScroll) * 100 : 0;
    pct = Math.max(0, Math.min(100, pct));
    fill.style.width = (PROGRESS_MIN_PCT + (100 - PROGRESS_MIN_PCT) * (pct / 100)) + '%';
  }

  sections.forEach(function (section) {
    const track = section.querySelector('.expand__track');
    if (!track) return;
    let rafId;
    track.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        syncActiveCard(section);
        syncProgress(section);
      });
    }, { passive: true });
    // Initial fill (mini nub) so the pill doesn't render at 0% width.
    syncProgress(section);
    window.addEventListener('resize', function () { syncProgress(section); }, { passive: true });
  });
  // If the viewport flips between mobile and desktop, re-evaluate so we don't
  // leave stale .is-card-expanded markers on the wrong viewport.
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', function () {
    sections.forEach(function (s) {
      s.querySelectorAll('.expand__card.is-card-expanded').forEach(function (c) { c.classList.remove('is-card-expanded'); });
      syncActiveCard(s);
    });
  });

  // Section enters viewport — expand once and stay expanded. Collapsing it again
  // would shrink the page mid-scroll and yank the viewport upward.
  // rootMargin shrinks the viewport by 30% top / 25% bottom for intersection
  // detection, so the section must be well into view (not just peeking at the
  // fold) before the cards animate open.
  if ('IntersectionObserver' in window) {
    const sectionIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-expanded');
          sectionIO.unobserve(entry.target);
          // Immediately mark the in-view card so the first one expands on
          // mobile without waiting for a scroll event.
          syncActiveCard(entry.target);
        }
      });
    }, { rootMargin: '-30% 0px -25% 0px', threshold: 0 });
    sections.forEach((s) => sectionIO.observe(s));
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-tcarousel]');
  sections.forEach((sec) => {
    const track = sec.querySelector('[data-track]');
    const prev = sec.querySelector('[data-prev]');
    const next = sec.querySelector('[data-next]');
    if (!track) return;

    const step = () => {
      const slide = track.querySelector('.tcarousel__slide');
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16') || 16;
      return slide ? slide.getBoundingClientRect().width + gap : 320;
    };
    const atStart = () => track.scrollLeft <= 2;
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

    // Loop: clicking past either end wraps around to the other side.
    prev && prev.addEventListener('click', () => {
      if (atStart()) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next && next.addEventListener('click', () => {
      if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    // Only surface arrows when there's content to scroll.
    function syncArrows() {
      const overflows = track.scrollWidth > track.clientWidth + 1;
      const mobile = window.matchMedia('(max-width: 900px)').matches;
      const show = overflows && !mobile;
      if (prev) prev.hidden = !show;
      if (next) next.hidden = !show;
    }

    syncArrows();
    let rRaf;
    const onResize = () => {
      if (rRaf) cancelAnimationFrame(rRaf);
      rRaf = requestAnimationFrame(syncArrows);
    };
    window.addEventListener('resize', onResize, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncArrows);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
